package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.ui.draw.clip
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AccountBox
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.colaboradores.CentroColab
import br.com.htms.inspeccaocampo.data.colaboradores.CnhDados
import br.com.htms.inspeccaocampo.data.colaboradores.ColabEscopo
import br.com.htms.inspeccaocampo.data.colaboradores.ColabDados
import br.com.htms.inspeccaocampo.data.colaboradores.ColabRegras
import br.com.htms.inspeccaocampo.data.colaboradores.Colaborador
import br.com.htms.inspeccaocampo.data.colaboradores.ColaboradoresApi
import br.com.htms.inspeccaocampo.data.colaboradores.DatasColab
import br.com.htms.inspeccaocampo.data.colaboradores.DocMatriz
import br.com.htms.inspeccaocampo.data.colaboradores.DocOutro
import br.com.htms.inspeccaocampo.data.colaboradores.DocsMatriz
import br.com.htms.inspeccaocampo.data.colaboradores.RegraDoc
import br.com.htms.inspeccaocampo.data.colaboradores.SituacaoDoc
import br.com.htms.inspeccaocampo.data.colaboradores.StatusColab
import br.com.htms.inspeccaocampo.data.colaboradores.StatusDoc
import br.com.htms.inspeccaocampo.data.funcionarios.Cpf
import br.com.htms.inspeccaocampo.data.funcionarios.Funcionario
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionarioDocumento
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionariosApi
import br.com.htms.inspeccaocampo.export.CertificadoModelo
import br.com.htms.inspeccaocampo.data.os.PgrCatalog
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.platform.PlatformFiles
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.platform.formatDateTimeBr
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.DateInputMask
import br.com.htms.inspeccaocampo.ui.kit.AvisoFaixa
import br.com.htms.inspeccaocampo.ui.kit.Campo
import br.com.htms.inspeccaocampo.ui.kit.CampoBusca
import br.com.htms.inspeccaocampo.ui.kit.PainelFixo
import br.com.htms.inspeccaocampo.ui.kit.CartaoBranco
import br.com.htms.inspeccaocampo.ui.kit.BotaoCores
import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.CoresDash
import br.com.htms.inspeccaocampo.ui.kit.Celula
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalho
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalhoOrdenavel
import br.com.htms.inspeccaocampo.ui.kit.rememberOrdem
import br.com.htms.inspeccaocampo.ui.kit.Ordenacao
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowLeft
import androidx.compose.material.icons.filled.KeyboardArrowRight
import androidx.compose.material.icons.filled.KeyboardArrowUp
import br.com.htms.inspeccaocampo.ui.kit.ChipCor
import br.com.htms.inspeccaocampo.ui.kit.Kpi
import br.com.htms.inspeccaocampo.ui.kit.LinhaKpis
import br.com.htms.inspeccaocampo.ui.kit.LinhaTabela
import br.com.htms.inspeccaocampo.ui.kit.Par
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModal
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.TabelaPortal
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardColaboradores
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import kotlin.math.roundToInt
import kotlinx.coroutines.launch


/** Filtros da lista de colaboradores (o painel abre a lista já filtrada). */
private data class FiltroColab(
    val busca: String = "",
    val situacao: String = "ATIVOS",
    val funcao: String = "",
    val cc: String = "",
    val status: String = "",
    val soPendentes: Boolean = false,
    val matriz: Boolean = true
)

private val SITUACOES = listOf("ATIVO", "AFASTADO", "AFASTADO (MATERNIDADE)", "DESATIVADO")

private fun norm(s: String): String = PgrCatalog.normalizar(s)

private fun cor(s: StatusDoc): Color = CoresDash.de(s.rotulo, s.cor)

private fun br(iso: String): String = DatasColab.isoParaBr(iso).ifBlank { "—" }

private fun brCurto(iso: String): String {
    val b = DatasColab.isoParaBr(iso)
    return if (b.length == 10) b.substring(0, 6) + b.substring(8) else "—"
}

private fun cpfMascarado(cpf: String): String {
    val d = Cpf.digitos(cpf)
    return if (d.length == 11) "•••.•••.${d.substring(6, 9)}-${d.substring(9)}" else d.ifBlank { "—" }
}

private val DocsColabLocal = staticCompositionLocalOf { DocsMatriz.todos }
private val SoVerColabLocal = staticCompositionLocalOf { false }
private val ExtrasColabLocal = staticCompositionLocalOf { true }
/** Quais chaves da matriz (OS, EPI, NR…) podem abrir o fluxo Gerar. */
private val PodeGerarDocLocal = staticCompositionLocalOf<(String) -> Boolean> { { true } }
private val CnhColabLocal = staticCompositionLocalOf { true }

@Composable
private fun docsTela(): List<DocMatriz> = DocsColabLocal.current

private fun textoDias(dias: Int?): String = when {
    dias == null -> ""
    dias < 0 -> "vencido há ${-dias} dia(s)"
    dias == 0 -> "vence hoje"
    else -> "em $dias dia(s)"
}

@Composable
fun SharedColaboradoresScreen(controller: AppController) {
    val scope = rememberCoroutineScope()
    var dados by remember { mutableStateOf<ColabDados?>(null) }
    var erro by remember { mutableStateOf<String?>(null) }
    var aviso by remember { mutableStateOf<String?>(null) }
    var aba by remember { mutableStateOf(ColabAba.PAINEL) }
    var vinculo by remember { mutableStateOf("") }
    var filtro by remember { mutableStateOf(FiltroColab()) }
    var filtroVenc by remember { mutableStateOf("") }
    var fichaId by remember { mutableStateOf<String?>(null) }
    var editando by remember { mutableStateOf<Colaborador?>(null) }
    var tick by remember { mutableStateOf(0) }
    val hoje = remember { DatasColab.hoje() }
    val authUser by controller.authUser.collectAsState()
    val appConfig by controller.appConfig.collectAsState()
    val visao = ColabEscopo.visao(authUser, appConfig)
    val soVer = visao?.somenteVer == true

    LaunchedEffect(tick) {
        ColaboradoresApi.dados()
            .onSuccess {
                dados = it
                erro = null
            }
            .onFailure { erro = it.message ?: "Falha ao carregar os colaboradores." }
    }

    fun aplicar(c: Colaborador) {
        dados = dados?.let { d ->
            d.copy(colaboradores = (d.colaboradores.filter { it.id != c.id } + c).sortedBy { norm(it.nome) })
        }
    }

    val salvar: suspend (Colaborador, String) -> String? = { c, acao ->
        ColaboradoresApi.salvar(c, acao).fold(
            onSuccess = {
                aplicar(it)
                aviso = "${it.nome}: alterações salvas."
                null
            },
            onFailure = { it.message ?: "Falha ao salvar." }
        )
    }

    val d = dados
    val todos = d?.colaboradores.orEmpty()
    val lista = todos.filter { vinculo.isBlank() || it.vinculo == vinculo }
    val regras = d?.regras ?: ColabRegras()
    val abrirLista: (FiltroColab) -> Unit = {
        if (visao == null || visao.mostra(ColabAba.COLABORADORES.name)) {
            filtro = it
            aba = ColabAba.COLABORADORES
        }
    }

    val subAbaPedido by controller.colaboradoresSubAba.collectAsState()
    LaunchedEffect(subAbaPedido, visao) {
        val permitidas = ColabAba.entries.filter { visao == null || visao.mostra(it.name) }
        val pedida = runCatching { ColabAba.valueOf(subAbaPedido) }.getOrNull()
        val destino = when {
            pedida != null && pedida in permitidas -> pedida
            aba in permitidas -> aba
            else -> permitidas.firstOrNull() ?: aba
        }
        if (aba != destino) aba = destino
    }

    val podeMudar = d?.podeEditar != false && !soVer
    CompositionLocalProvider(
        DocsColabLocal provides if (visao == null) DocsMatriz.todos else DocsMatriz.todos.filter { visao.doc(it.key) },
        SoVerColabLocal provides soVer,
        ExtrasColabLocal provides (visao == null),
        CnhColabLocal provides (visao == null || visao.mostra("CNH")),
        PodeGerarDocLocal provides { chave ->
            if (visao == null) true
            else when (chave) {
                "ASO" -> false
                "OS" -> visao.mostra(ColabEscopo.DOC_OS)
                "EPI" -> visao.mostra(ColabEscopo.DOC_EPI)
                else -> visao.mostra(ColabEscopo.DOC_CERTIFICADO)
            }
        }
    ) {
    ColabQsmsModulo(
        controller = controller,
        titulo = "Colaboradores — QSMS",
        selecionado = aba.name,
        extraCabecalho = {
            if (aba != ColabAba.COLABORADORES) {
                FiltroVinculo(vinculo) { vinculo = it }
                Spacer(Modifier.width(10.dp))
                BotaoPlanilha(controller, br.com.htms.inspeccaocampo.export.PlanilhaModulo.COLABORADORES)
                Spacer(Modifier.width(8.dp))
                Button(onClick = { editando = Colaborador(situacao = "ATIVO") }, enabled = podeMudar) { Text("+ Novo") }
            }
        }
    ) { largo ->
        aviso?.let { AvisoFaixa(it) { aviso = null } }
        erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
        if (d == null) {
            if (erro == null) CircularProgressIndicator(color = PortalCores.Navy)
            return@ColabQsmsModulo
        }
        when (aba) {
            ColabAba.DASHBOARD -> DashboardColaboradores(d) { tick++ }
            ColabAba.PAINEL -> PainelColab(
                lista, regras, hoje, largo,
                onLista = abrirLista,
                onVencimentos = { status ->
                    if (visao == null || visao.mostra(ColabAba.VENCIMENTOS.name)) {
                        filtroVenc = status
                        aba = ColabAba.VENCIMENTOS
                    }
                },
                onAba = { if (visao == null || visao.mostra(it.name)) aba = it },
                onAbrir = { fichaId = it }
            )
            ColabAba.COLABORADORES -> ListaColab(
                lista, d.centros, regras, hoje, largo, filtro,
                vinculo = vinculo,
                onVinculo = { vinculo = it },
                onNovo = { editando = Colaborador(situacao = "ATIVO") },
                podeNovo = podeMudar,
                controller = controller,
                onFiltro = { filtro = it },
                onAbrir = { fichaId = it }
            )
            ColabAba.VENCIMENTOS -> VencimentosColab(
                lista, regras, hoje, largo, filtroVenc,
                onFiltroStatus = { filtroVenc = it },
                onAbrir = { fichaId = it },
                salvar = salvar
            )
            ColabAba.CNH -> CnhColab(lista, regras, hoje, largo, onAbrir = { fichaId = it }, salvar = salvar)
            ColabAba.PENDENCIAS -> PendenciasColab(lista, regras, hoje, onAbrir = { fichaId = it })
            ColabAba.REGRAS -> RegrasColab(regras, d.podeRegras && !soVer) { novas ->
                ColaboradoresApi.salvarRegras(novas).fold(
                    onSuccess = {
                        dados = dados?.copy(regras = it)
                        aviso = "Regras de validade salvas."
                        null
                    },
                    onFailure = { it.message ?: "Falha ao salvar as regras." }
                )
            }
            ColabAba.BACKUP -> BackupColab(d, largo, onAviso = { aviso = it }, onRecarregar = { tick++ })
        }
    }

    val ficha = fichaId?.let { id -> todos.firstOrNull { it.id == id } }
    if (ficha != null && editando == null) {
        FichaColab(
            controller = controller,
            centros = d?.centros.orEmpty(),
            c = ficha,
            regras = regras,
            hoje = hoje,
            podeEditar = podeMudar,
            podeExcluir = d?.podeExcluir == true && !soVer,
            onFechar = { fichaId = null },
            onEditar = { editando = ficha },
            salvar = salvar,
            onExcluir = {
                scope.launch {
                    ColaboradoresApi.excluir(ficha.id)
                        .onSuccess {
                            dados = dados?.let { x -> x.copy(colaboradores = x.colaboradores.filter { it.id != ficha.id }) }
                            fichaId = null
                            aviso = "${ficha.nome} excluído."
                        }
                        .onFailure { aviso = it.message ?: "Falha ao excluir." }
                }
            }
        )
    }
    if (!soVer) editando?.let { atual ->
        PortalModal(onFechar = { editando = null }) {
            FormColab(
                inicial = atual,
                funcoes = todos.map { it.funcao }.filter { it.isNotBlank() }.distinct().sorted(),
                centros = d?.centros.orEmpty(),
                onCancelar = { editando = null },
                salvar = { c ->
                    val r = salvar(c, if (c.id.isBlank()) "" else "Cadastro editado")
                    if (r == null) {
                        editando = null
                        if (c.id.isBlank()) {
                            fichaId = dados?.colaboradores?.firstOrNull { norm(it.nome) == norm(c.nome) && it.vinculo == c.vinculo }?.id
                        }
                    }
                    r
                }
            )
        }
    }
    }
}

@Composable
private fun FiltroVinculo(valor: String, onChange: (String) -> Unit) {
    Row(
        Modifier.border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp)),
        verticalAlignment = Alignment.CenterVertically
    ) {
        listOf("" to "Todos", "CLT" to "CLT", "PJ" to "PJ").forEach { (v, rot) ->
            val sel = v == valor
            Text(
                rot,
                color = if (sel) Color.White else PortalCores.Navy,
                fontWeight = if (sel) FontWeight.SemiBold else FontWeight.Normal,
                modifier = Modifier
                    .background(if (sel) PortalCores.Marca else Color.Transparent, RoundedCornerShape(10.dp))
                    .clickable { onChange(v) }
                    .padding(horizontal = 14.dp, vertical = 8.dp)
            )
        }
    }
}

// ---------------------------------------------------------------- Painel

private class Contagem(
    lista: List<Colaborador>,
    regras: ColabRegras,
    hoje: Long,
    docs: List<DocMatriz> = DocsMatriz.todos,
    incluirOutros: Boolean = true
) {
    val ativos = lista.filter { it.noQuadro(DatasColab.isoDeDias(hoje)) }
    val porStatus: Map<StatusDoc, Int>
    val pessoasPendentes: Int
    val conformidade: Double

    init {
        val m = mutableMapOf<StatusDoc, Int>()
        var pessoas = 0
        for (c in ativos) {
            var pend = false
            for (doc in docs) {
                val s = StatusColab.doc(c, doc.key, regras, hoje).status
                m[s] = (m[s] ?: 0) + 1
                if (s == StatusDoc.PENDENTE) pend = true
            }
            if (!incluirOutros) continue
            for (doc in c.outros) {
                val s = StatusColab.outro(doc, regras, hoje).status
                m[s] = (m[s] ?: 0) + 1
                if (s == StatusDoc.PENDENTE || s == StatusDoc.VENCIDO) pend = true
            }
            if (pend) pessoas++
        }
        porStatus = m
        pessoasPendentes = pessoas
        val emDia = n(StatusDoc.VALIDO) + n(StatusDoc.ATENCAO) + n(StatusDoc.CRITICO)
        val total = emDia + n(StatusDoc.VENCIDO) + n(StatusDoc.PENDENTE)
        conformidade = if (total == 0) 100.0 else (emDia * 1000 / total) / 10.0
    }

    fun n(s: StatusDoc): Int = porStatus[s] ?: 0
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun PainelColab(
    lista: List<Colaborador>,
    regras: ColabRegras,
    hoje: Long,
    largo: Boolean,
    onLista: (FiltroColab) -> Unit,
    onVencimentos: (String) -> Unit,
    onAba: (ColabAba) -> Unit,
    onAbrir: (String) -> Unit
) {
    val docsPainel = docsTela()
    val extrasPainel = ExtrasColabLocal.current
    val ct = remember(lista, regras, docsPainel, extrasPainel) { Contagem(lista, regras, hoje, docsPainel, extrasPainel) }
    BotaoCores(StatusDoc.entries.map { it.rotulo to it.cor })
    val corConf = when {
        ct.conformidade >= 90 -> PortalCores.Verde
        ct.conformidade >= 75 -> PortalCores.Laranja
        else -> PortalCores.Vermelho
    }
    LinhaKpis(largo) { m ->
        Kpi("Ativos", ct.ativos.size.toString(), Icons.Filled.Person, m, legenda = "${lista.size} no cadastro",
            onClick = { onLista(FiltroColab()) })
        Kpi("Vencidos", ct.n(StatusDoc.VENCIDO).toString(), Icons.Filled.Warning, m, cor = cor(StatusDoc.VENCIDO),
            legenda = "documentos", onClick = { onVencimentos(StatusDoc.VENCIDO.name) })
        Kpi("Críticos", ct.n(StatusDoc.CRITICO).toString(), Icons.Filled.DateRange, m, cor = cor(StatusDoc.CRITICO),
            legenda = "vencem em até ${regras.crit} dias", onClick = { onVencimentos(StatusDoc.CRITICO.name) })
    }
    LinhaKpis(largo) { m ->
        Kpi("Atenção", ct.n(StatusDoc.ATENCAO).toString(), Icons.Filled.DateRange, m, cor = cor(StatusDoc.ATENCAO),
            legenda = "vencem em até ${regras.aten} dias", onClick = { onVencimentos(StatusDoc.ATENCAO.name) })
        Kpi("Pendências", ct.n(StatusDoc.PENDENTE).toString(), Icons.Filled.Warning, m, cor = cor(StatusDoc.PENDENTE),
            legenda = "obrigatórios sem registro (${ct.pessoasPendentes} pessoas)", onClick = { onAba(ColabAba.PENDENCIAS) })
        Kpi("Conformidade", "${ct.conformidade.toString().replace('.', ',')}%", Icons.Filled.Home, m, cor = corConf,
            legenda = "documentos em dia")
    }

    val alertas = buildList {
        if (ct.n(StatusDoc.VENCIDO) > 0) add(Triple("${ct.n(StatusDoc.VENCIDO)} documento(s) vencido(s)", StatusDoc.VENCIDO) { onVencimentos(StatusDoc.VENCIDO.name) })
        if (ct.n(StatusDoc.CRITICO) > 0) add(Triple("${ct.n(StatusDoc.CRITICO)} documento(s) vencem em até ${regras.crit} dias", StatusDoc.CRITICO) { onVencimentos(StatusDoc.CRITICO.name) })
        if (ct.n(StatusDoc.PENDENTE) > 0) add(Triple("${ct.pessoasPendentes} colaborador(es) com documento obrigatório sem registro", StatusDoc.PENDENTE) { onAba(ColabAba.PENDENCIAS) })
        val cnhVenc = ct.ativos.count { StatusColab.cnh(it, regras, hoje).status == StatusDoc.VENCIDO }
        if (cnhVenc > 0) add(Triple("$cnhVenc CNH vencida(s)", StatusDoc.VENCIDO) { onAba(ColabAba.CNH) })
        val verificar = ct.ativos.count { StatusColab.cnh(it, regras, hoje).status == StatusDoc.VERIFICAR }
        if (verificar > 0) add(Triple("$verificar colaborador(es) em função de condução sem CNH informada", StatusDoc.VERIFICAR) { onAba(ColabAba.CNH) })
        val semCpf = ct.ativos.count { it.cpf.isBlank() }
        if (semCpf > 0) add(Triple("$semCpf colaborador(es) ativo(s) sem CPF", StatusDoc.SEM_REGISTRO) { onAba(ColabAba.PENDENCIAS) })
        val fora = lista.count { it.foraMatriz }
        if (fora > 0) add(Triple("$fora cadastro(s) fora da matriz para revisar", StatusDoc.ATENCAO) { onLista(FiltroColab(situacao = "FORA")) })
    }
    CartaoSecao("Alertas automáticos") {
        if (alertas.isEmpty()) {
            Text("Nenhum alerta. Tudo em dia.", color = PortalCores.Verde)
        } else {
            alertas.forEach { (texto, st, acao) ->
                Row(
                    Modifier.fillMaxWidth().clickable { acao() }.padding(vertical = 4.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Box(Modifier.size(10.dp).background(cor(st), RoundedCornerShape(5.dp)))
                    Spacer(Modifier.width(10.dp))
                    Text(texto, Modifier.weight(1f), color = PortalCores.Texto)
                    Text("Ver", color = PortalCores.Navy, fontWeight = FontWeight.SemiBold)
                }
            }
        }
    }

    val barras: @Composable (Modifier) -> Unit = { m -> BarrasDocumentos(ct.ativos, regras, hoje, m) }
    val proximos: @Composable (Modifier) -> Unit = { m -> ProximosVencimentos(ct.ativos, regras, hoje, m, onAbrir) }
    if (largo) {
        Row(horizontalArrangement = Arrangement.spacedBy(18.dp), verticalAlignment = Alignment.Top) {
            barras(Modifier.weight(1.4f))
            proximos(Modifier.weight(1f))
        }
    } else {
        barras(Modifier.fillMaxWidth())
        proximos(Modifier.fillMaxWidth())
    }
    if (CnhColabLocal.current) ResumoCnh(ct.ativos, regras, hoje, largo) { onAba(ColabAba.CNH) }
}

@Composable
private fun BarrasDocumentos(ativos: List<Colaborador>, regras: ColabRegras, hoje: Long, modifier: Modifier) {
    val ordem = listOf(StatusDoc.VALIDO, StatusDoc.ATENCAO, StatusDoc.CRITICO, StatusDoc.VENCIDO, StatusDoc.PENDENTE)
    CartaoSecao("Situação por documento", modifier, subtitulo = "Colaboradores ativos; N/A e sem registro opcional ficam de fora") {
        docsTela().forEach { doc ->
            val cont = ordem.associateWith { 0 }.toMutableMap()
            for (c in ativos) {
                val s = StatusColab.doc(c, doc.key, regras, hoje).status
                if (s in cont) cont[s] = cont.getValue(s) + 1
            }
            val n = cont.values.sum()
            val ok = cont.getValue(StatusDoc.VALIDO) + cont.getValue(StatusDoc.ATENCAO) + cont.getValue(StatusDoc.CRITICO)
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(doc.rotulo, Modifier.width(78.dp), color = PortalCores.TextoForte, style = MaterialTheme.typography.bodyMedium)
                Row(
                    Modifier.weight(1f).height(14.dp).background(PortalCores.CabecalhoTabela, RoundedCornerShape(7.dp))
                ) {
                    if (n > 0) {
                        ordem.forEach { s ->
                            val q = cont.getValue(s)
                            if (q > 0) Box(Modifier.weight(q.toFloat()).height(14.dp).background(cor(s)))
                        }
                    }
                }
                Text(
                    if (n == 0) "—" else "${ok * 100 / n}%",
                    Modifier.width(52.dp),
                    textAlign = TextAlign.End,
                    color = PortalCores.Texto,
                    fontWeight = FontWeight.SemiBold
                )
            }
        }
        LegendaStatus(ordem)
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun LegendaStatus(itens: List<StatusDoc>) {
    FlowRow(horizontalArrangement = Arrangement.spacedBy(14.dp)) {
        itens.forEach { s ->
            Row(verticalAlignment = Alignment.CenterVertically) {
                Box(Modifier.size(10.dp).background(cor(s), RoundedCornerShape(3.dp)))
                Spacer(Modifier.width(5.dp))
                Text(s.rotulo, style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
            }
        }
    }
}

@Composable
private fun ProximosVencimentos(
    ativos: List<Colaborador>,
    regras: ColabRegras,
    hoje: Long,
    modifier: Modifier,
    onAbrir: (String) -> Unit
) {
    val docs = docsTela()
    val itens = remember(ativos, regras, docs) {
        ativos.flatMap { c ->
            docs.mapNotNull { doc ->
                val s = StatusColab.doc(c, doc.key, regras, hoje)
                if (s.dias != null && s.dias in 0..regras.aten) Triple(c, doc.rotulo, s) else null
            }
        }.sortedBy { it.third.dias }.take(12)
    }
    CartaoSecao("Próximos vencimentos", modifier, subtitulo = "Até ${regras.aten} dias") {
        if (itens.isEmpty()) Text("Nada vence nos próximos ${regras.aten} dias.", color = PortalCores.CinzaTexto)
        itens.forEach { (c, rot, s) ->
            Row(
                Modifier.fillMaxWidth().clickable { onAbrir(c.id) }.padding(vertical = 3.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(Modifier.weight(1f)) {
                    Text(c.nome, color = PortalCores.Texto, fontWeight = FontWeight.SemiBold, maxLines = 1, overflow = TextOverflow.Ellipsis)
                    Text("$rot · vence ${br(s.vencimento)} (${textoDias(s.dias)})", style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                }
                ChipCor(s.status.rotulo, cor(s.status))
            }
        }
    }
}

@Composable
private fun ResumoCnh(ativos: List<Colaborador>, regras: ColabRegras, hoje: Long, largo: Boolean, onAbrir: () -> Unit) {
    val st = ativos.map { StatusColab.cnh(it, regras, hoje).status }
    val com = ativos.count { it.cnh.aplica == "sim" }
    CartaoSecao("CNH", subtitulo = "Colaboradores ativos", acoes = { TextButton(onClick = onAbrir) { Text("Abrir CNH") } }) {
        LinhaKpis(largo) { m ->
            Kpi("Possuem CNH", com.toString(), Icons.Filled.AccountBox, m)
            Kpi("Sem validade", st.count { it == StatusDoc.PENDENTE }.toString(), Icons.Filled.Warning, m, cor = cor(StatusDoc.PENDENTE))
            Kpi("Vencendo", st.count { it == StatusDoc.CRITICO || it == StatusDoc.ATENCAO }.toString(), Icons.Filled.DateRange, m, cor = cor(StatusDoc.CRITICO))
            Kpi("Vencidas", st.count { it == StatusDoc.VENCIDO }.toString(), Icons.Filled.Warning, m, cor = cor(StatusDoc.VENCIDO))
        }
    }
}

// ---------------------------------------------------------------- Colaboradores

private fun filtrar(
    lista: List<Colaborador>,
    f: FiltroColab,
    regras: ColabRegras,
    hoje: Long,
    docs: List<DocMatriz> = DocsMatriz.todos,
    incluirOutros: Boolean = true,
    incluirCnh: Boolean = true
): List<Colaborador> {
    val termo = norm(f.busca.trim())
    val digitos = f.busca.filter { it.isDigit() }
    val statusSel = f.status.takeIf { it.isNotBlank() }?.let { StatusDoc.valueOf(it) }
    return lista.filter { c ->
        when (f.situacao) {
            "ATIVOS" -> c.noQuadro(DatasColab.isoDeDias(hoje))
            "AFASTADOS" -> c.situacao.uppercase().startsWith("AFAST")
            "DESATIVADOS" -> c.desativado
            "FORA" -> c.foraMatriz
            else -> true
        }
    }.filter { c ->
        termo.isEmpty() ||
            norm("${c.nome} ${c.funcao} ${c.matricula}").contains(termo) ||
            (digitos.length >= 3 && Cpf.digitos(c.cpf).contains(digitos))
    }.filter { c -> f.funcao.isBlank() || c.funcao == f.funcao }
        .filter { c ->
            when (f.cc) {
                "" -> true
                SEM_CC -> c.ccId.isBlank()
                else -> c.ccId == f.cc
            }
        }
        .filter { c ->
            statusSel == null || docs.any { StatusColab.doc(c, it.key, regras, hoje).status == statusSel } ||
                (incluirOutros && c.outros.any { StatusColab.outro(it, regras, hoje).status == statusSel }) ||
                (incluirCnh && StatusColab.cnh(c, regras, hoje).status == statusSel)
        }
        .filter { c ->
            if (!f.soPendentes) true
            else docs.any {
                val s = StatusColab.doc(c, it.key, regras, hoje).status
                s == StatusDoc.PENDENTE || s == StatusDoc.VENCIDO
            } || (incluirOutros && c.outros.any {
                val s = StatusColab.outro(it, regras, hoje).status
                s == StatusDoc.PENDENTE || s == StatusDoc.VENCIDO
            })
        }
}

private const val SEM_CC = "__SEM__"

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ListaColab(
    lista: List<Colaborador>,
    centros: List<CentroColab>,
    regras: ColabRegras,
    hoje: Long,
    largo: Boolean,
    f: FiltroColab,
    vinculo: String,
    onVinculo: (String) -> Unit,
    onNovo: () -> Unit,
    podeNovo: Boolean,
    controller: br.com.htms.inspeccaocampo.form.AppController,
    onFiltro: (FiltroColab) -> Unit,
    onAbrir: (String) -> Unit
) {
    val docsLista = docsTela()
    val extrasLista = ExtrasColabLocal.current
    val cnhLista = CnhColabLocal.current
    val filtrados = remember(lista, f, regras, docsLista, extrasLista, cnhLista) {
        filtrar(lista, f, regras, hoje, docsLista, extrasLista, cnhLista)
    }
    val funcoes = remember(lista) { lista.map { it.funcao }.filter { it.isNotBlank() }.distinct().sorted() }
    val filtros: @Composable ColumnScope.() -> Unit = {
        FlowRow(
            Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Column(Modifier.weight(1f).padding(end = 8.dp)) {
                Text("Colaboradores", color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge)
                Text("${filtrados.size} de ${lista.size}", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
            }
            FiltroVinculo(vinculo, onVinculo)
            FiltroVinculoModo(f.matriz) { onFiltro(f.copy(matriz = it)) }
            BotaoPlanilha(controller, br.com.htms.inspeccaocampo.export.PlanilhaModulo.COLABORADORES)
            Button(onClick = onNovo, enabled = podeNovo) { Text("+ Novo") }
        }
        FlowRow(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            val w = if (largo) Modifier.width(230.dp) else Modifier.fillMaxWidth()
            CampoBusca(f.busca, { onFiltro(f.copy(busca = it)) }, "Nome, função, MTR ou CPF", if (largo) Modifier.width(300.dp) else Modifier.fillMaxWidth())
            Seletor(
                "Situação",
                listOf("ATIVOS" to "Ativos", "AFASTADOS" to "Afastados", "DESATIVADOS" to "Desativados", "FORA" to "Fora da matriz", "TODOS" to "Todos"),
                f.situacao,
                { onFiltro(f.copy(situacao = it)) },
                w
            )
            Seletor("Função", listOf("" to "Todas") + funcoes.map { it to it }, f.funcao, { onFiltro(f.copy(funcao = it)) }, w)
            val centrosFiltro = centros
                .filter { it.ativo || lista.any { c -> c.ccId == it.id } }
                .sortedBy { it.rotulo }
            Seletor(
                "Centro de custo/Obra",
                listOf("" to "Todos", SEM_CC to "Sem centro de custo/obra") + centrosFiltro.map { it.id to it.rotulo },
                f.cc,
                { onFiltro(f.copy(cc = it)) },
                if (largo) Modifier.width(340.dp) else Modifier.fillMaxWidth()
            )
            Seletor("Status", listOf("" to "Qualquer") + StatusDoc.entries.map { it.name to it.rotulo }, f.status, { onFiltro(f.copy(status = it)) }, w)
            Row(verticalAlignment = Alignment.CenterVertically) {
                Checkbox(checked = f.soPendentes, onCheckedChange = { onFiltro(f.copy(soPendentes = it)) })
                Text("Só com vencido ou pendente")
            }
        }
    }
    val codigoPorId = remember(centros) { centros.associate { it.id to it.codigo } }
    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth().padding(18.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            if (filtrados.isEmpty()) {
                PainelFixo {
                    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        filtros()
                        Text("Nenhum colaborador com esses filtros.", color = PortalCores.CinzaTexto)
                    }
                }
            } else if (f.matriz) {
                MatrizColab(filtrados, codigoPorId, regras, hoje, onAbrir, filtros)
            } else if (largo) {
                TabelaColab(filtrados, codigoPorId, regras, hoje, onAbrir, filtros)
            } else {
                PainelFixo {
                    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { filtros() }
                }
                filtrados.forEach { c -> CartaoColabCompacto(c, codigoPorId[c.ccId].orEmpty(), regras, hoje) { onAbrir(c.id) } }
            }
        }
    }
}

@Composable
private fun FiltroVinculoModo(matriz: Boolean, onChange: (Boolean) -> Unit) {
    Row(Modifier.border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp))) {
        listOf(true to "Matriz", false to "Lista").forEach { (v, rot) ->
            val sel = v == matriz
            Text(
                rot,
                color = if (sel) Color.White else PortalCores.Navy,
                modifier = Modifier
                    .background(if (sel) PortalCores.Marca else Color.Transparent, RoundedCornerShape(10.dp))
                    .clickable { onChange(v) }
                    .padding(horizontal = 12.dp, vertical = 7.dp)
            )
        }
    }
}

private val LARG_NOME: Dp = 250.dp
private val LARG_FUNCAO: Dp = 170.dp
private val LARG_CONTRATO: Dp = 78.dp
private val LARG_SIT: Dp = 130.dp
private val LARG_CC: Dp = 72.dp
private val LARG_DOC: Dp = 78.dp

@Composable
private fun CelulaFixa(texto: String, largura: Dp, negrito: Boolean = false, cor: Color = PortalCores.Texto, fundo: Color = Color.Transparent) {
    Box(Modifier.width(largura).padding(horizontal = 3.dp), contentAlignment = Alignment.CenterStart) {
        Text(
            texto,
            modifier = Modifier.fillMaxWidth().background(fundo, RoundedCornerShape(6.dp)).padding(horizontal = 6.dp, vertical = 4.dp),
            color = cor,
            fontWeight = if (negrito) FontWeight.SemiBold else FontWeight.Normal,
            style = MaterialTheme.typography.bodySmall,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

/** Cabeçalho da matriz que ordena ao clicar; [crescente] null = coluna fora da ordenação. */
@Composable
private fun CelulaFixaOrdenavel(texto: String, largura: Dp, crescente: Boolean?, onClick: () -> Unit) {
    Row(
        Modifier.width(largura).padding(horizontal = 3.dp).clip(RoundedCornerShape(6.dp)).clickable(onClick = onClick)
            .padding(horizontal = 6.dp, vertical = 4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            texto,
            modifier = Modifier.weight(1f, fill = false),
            color = if (crescente != null) PortalCores.Navy else PortalCores.TextoForte,
            fontWeight = FontWeight.SemiBold,
            style = MaterialTheme.typography.bodySmall,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        androidx.compose.material3.Icon(
            if (crescente == true) Icons.Filled.KeyboardArrowUp else Icons.Filled.KeyboardArrowDown,
            contentDescription = null,
            tint = if (crescente != null) PortalCores.Navy else PortalCores.CinzaTexto.copy(alpha = 0.45f),
            modifier = Modifier.size(16.dp)
        )
    }
}

/** dd/mm/aaaa -> aaaa/mm/dd para ordenar como data (ISO já ordena). */
private fun dataOrdenavel(s: String): String {
    val p = s.trim().split('/')
    return if (p.size == 3) "${p[2]}/${p[1]}/${p[0]}" else s.trim()
}

/** Chaves: MTR, NOME, FUNCAO, VINCULO, SITUACAO, CC, ADMISSAO, NASCIMENTO, RG, CPF, DOCS, CNH ou DOC:<chave do documento>. */
private fun ordenarColab(
    lista: List<Colaborador>,
    col: String,
    asc: Boolean,
    regras: ColabRegras,
    hoje: Long,
    codigoPorId: Map<String, String> = emptyMap()
): List<Colaborador> {
    val cmp: Comparator<Colaborador> = when {
        col == "MTR" -> Ordenacao.por(asc) { it.matricula }
        col == "FUNCAO" -> Ordenacao.por(asc) { it.funcao }
        col == "VINCULO" -> Ordenacao.por(asc) { it.vinculo }
        col == "SITUACAO" -> Ordenacao.por(asc) { it.situacao }
        col == "CC" -> Ordenacao.por(asc) { codigoPorId[it.ccId].orEmpty() }
        col == "ADMISSAO" -> Ordenacao.por(asc) { dataOrdenavel(it.admissao) }
        col == "NASCIMENTO" -> Ordenacao.por(asc) { dataOrdenavel(it.nascimento) }
        col == "RG" -> Ordenacao.por(asc) { it.rg }
        col == "CPF" -> Ordenacao.por(asc) { it.cpf }
        col == "DOCS" -> Ordenacao.porNumero(asc) { StatusColab.pior(it, regras, hoje).ordinal.toDouble() }
        col == "CNH" -> Ordenacao.por(asc) { StatusColab.cnh(it, regras, hoje).vencimento }
        col.startsWith("DOC:") -> {
            val key = col.removePrefix("DOC:")
            Ordenacao.por(asc) { c -> StatusColab.doc(c, key, regras, hoje).let { s -> s.vencimento.ifBlank { s.realizado } } }
        }
        else -> Ordenacao.por(asc) { it.nome }
    }
    return lista.sortedWith(cmp.then(Ordenacao.por(true) { it.nome }))
}

private fun textoCelulaDoc(c: Colaborador, key: String, s: SituacaoDoc): String = when (s.status) {
    StatusDoc.NA -> "N/A"
    StatusDoc.PENDENTE -> "PEND."
    StatusDoc.SEM_REGISTRO -> "—"
    else -> if (s.vencimento.isNotBlank()) brCurto(s.vencimento) else if (c.docs[key] == "OK") "OK" else brCurto(s.realizado)
}

@Composable
private fun MatrizColab(
    todos: List<Colaborador>,
    codigoPorId: Map<String, String>,
    regras: ColabRegras,
    hoje: Long,
    onAbrir: (String) -> Unit,
    acima: @Composable ColumnScope.() -> Unit
) {
    var ordemCol by remember { mutableStateOf("NOME") }
    var ordemAsc by remember { mutableStateOf(true) }
    fun ordenar(col: String) {
        if (ordemCol == col) ordemAsc = !ordemAsc else { ordemCol = col; ordemAsc = true }
    }
    fun cres(col: String): Boolean? = if (ordemCol == col) ordemAsc else null
    val lista = remember(todos, ordemCol, ordemAsc, regras, hoje, codigoPorId) {
        ordenarColab(todos, ordemCol, ordemAsc, regras, hoje, codigoPorId)
    }
    val docsMatriz = docsTela()
    val mostrarCnh = CnhColabLocal.current
    val chaves = remember(docsMatriz, mostrarCnh) {
        listOf("NOME", "FUNCAO", "VINCULO", "SITUACAO", "CC") +
            docsMatriz.map { "DOC:" + it.key } +
            (if (mostrarCnh) listOf("CNH") else emptyList())
    }
    var larguras by remember {
        mutableStateOf(
            chaves.associateWith { chave ->
                when (chave) {
                    "NOME" -> LARG_NOME
                    "FUNCAO" -> LARG_FUNCAO
                    "VINCULO" -> LARG_CONTRATO
                    "SITUACAO" -> LARG_SIT
                    "CC" -> LARG_CC
                    else -> LARG_DOC
                }
            }
        )
    }
    fun larg(chave: String): Dp = larguras[chave] ?: LARG_DOC
    fun ajustar(chave: String, nova: Dp) {
        larguras = larguras + (chave to nova.coerceIn(52.dp, 460.dp))
    }
    val scroll = rememberScrollState()
    var vista by remember { mutableIntStateOf(0) }
    PainelFixo {
        Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            acima()
            Text(
                "Cada célula mostra a data de vencimento. Arraste a borda do título para ajustar a coluna e use a barra para ver o restante.",
                style = MaterialTheme.typography.bodySmall,
                color = PortalCores.CinzaTexto
            )
            Column(Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(topStart = 10.dp, topEnd = 10.dp))) {
                BarraNavHorizontal(scroll, vista)
                Box(Modifier.fillMaxWidth().onSizeChanged { vista = it.width }) {
                    Row(Modifier.horizontalScroll(scroll).background(PortalCores.CabecalhoTabela).padding(vertical = 8.dp, horizontal = 6.dp)) {
                    CabMatriz("Colaborador", larg("NOME"), cres("NOME"), { ordenar("NOME") }) { ajustar("NOME", it) }
                    CabMatriz("Função", larg("FUNCAO"), cres("FUNCAO"), { ordenar("FUNCAO") }) { ajustar("FUNCAO", it) }
                    CabMatriz("Contrato", larg("VINCULO"), cres("VINCULO"), { ordenar("VINCULO") }) { ajustar("VINCULO", it) }
                    CabMatriz("Situação", larg("SITUACAO"), cres("SITUACAO"), { ordenar("SITUACAO") }) { ajustar("SITUACAO", it) }
                    CabMatriz("CC", larg("CC"), cres("CC"), { ordenar("CC") }) { ajustar("CC", it) }
                    docsMatriz.forEach { d ->
                        val chave = "DOC:" + d.key
                        CabMatriz(d.rotulo, larg(chave), cres(chave), { ordenar(chave) }) { ajustar(chave, it) }
                    }
                    if (mostrarCnh) CabMatriz("CNH", larg("CNH"), cres("CNH"), { ordenar("CNH") }) { ajustar("CNH", it) }
                    }
                }
            }
        }
    }
    Column(Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(bottomStart = 10.dp, bottomEnd = 10.dp))) {
        Box(Modifier.fillMaxWidth().onSizeChanged { vista = it.width }) {
            Column(Modifier.horizontalScroll(scroll)) {
                lista.forEach { c ->
                    HorizontalDivider(color = PortalCores.Borda)
                    Row(
                        Modifier.clickable { onAbrir(c.id) }.padding(vertical = 4.dp, horizontal = 6.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        CelulaFixa(c.nome, larg("NOME"), negrito = true, cor = PortalCores.Navy)
                        CelulaFixa(c.funcao.ifBlank { "—" }, larg("FUNCAO"), cor = PortalCores.CinzaTexto)
                        CelulaFixa(c.vinculo.ifBlank { "—" }, larg("VINCULO"))
                        CelulaFixa(
                            c.situacao.ifBlank { "—" },
                            larg("SITUACAO"),
                            cor = if (c.desativado) PortalCores.CinzaClaro else PortalCores.Texto
                        )
                        CelulaFixa(codigoPorId[c.ccId].orEmpty().ifBlank { "—" }, larg("CC"))
                        docsMatriz.forEach { doc ->
                            val s = StatusColab.doc(c, doc.key, regras, hoje)
                            val corS = cor(s.status)
                            val neutro = s.status == StatusDoc.NA || s.status == StatusDoc.SEM_REGISTRO
                            CelulaFixa(
                                textoCelulaDoc(c, doc.key, s),
                                larg("DOC:" + doc.key),
                                negrito = !neutro,
                                cor = if (neutro) PortalCores.CinzaClaro else corS,
                                fundo = if (neutro) Color.Transparent else corS.copy(alpha = 0.10f)
                            )
                        }
                        if (mostrarCnh) {
                        val cnh = StatusColab.cnh(c, regras, hoje)
                        val corC = cor(cnh.status)
                        CelulaFixa(
                            when (cnh.status) {
                                StatusDoc.NA -> "N/A"
                                StatusDoc.NAO_INFORMADO -> "—"
                                StatusDoc.VERIFICAR -> "VERIF."
                                StatusDoc.PENDENTE -> "S/ VAL."
                                else -> brCurto(cnh.vencimento)
                            },
                            larg("CNH"),
                            cor = corC,
                            fundo = if (cnh.status == StatusDoc.NA || cnh.status == StatusDoc.NAO_INFORMADO) Color.Transparent else corC.copy(alpha = 0.10f)
                        )
                        }
                    }
                }
            }
        }
    }
    LegendaStatus(listOf(StatusDoc.VALIDO, StatusDoc.ATENCAO, StatusDoc.CRITICO, StatusDoc.VENCIDO, StatusDoc.PENDENTE, StatusDoc.VERIFICAR))
}

@Composable
private fun CabMatriz(texto: String, largura: Dp, crescente: Boolean?, onOrdenar: () -> Unit, onAjustar: (Dp) -> Unit) {
    val atual by rememberUpdatedState(largura)
    val ajustar by rememberUpdatedState(onAjustar)
    Box(Modifier.width(largura).height(32.dp)) {
        Row(
            Modifier.fillMaxWidth().padding(end = 8.dp).clip(RoundedCornerShape(6.dp)).clickable(onClick = onOrdenar)
                .padding(horizontal = 6.dp, vertical = 4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                texto,
                modifier = Modifier.weight(1f, fill = false),
                color = if (crescente != null) PortalCores.Navy else PortalCores.TextoForte,
                fontWeight = FontWeight.SemiBold,
                style = MaterialTheme.typography.bodySmall,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            androidx.compose.material3.Icon(
                if (crescente == true) Icons.Filled.KeyboardArrowUp else Icons.Filled.KeyboardArrowDown,
                contentDescription = null,
                tint = if (crescente != null) PortalCores.Navy else PortalCores.CinzaTexto.copy(alpha = 0.45f),
                modifier = Modifier.size(16.dp)
            )
        }
        Box(
            Modifier
                .align(Alignment.CenterEnd)
                .width(10.dp)
                .fillMaxHeight()
                .pointerInput(Unit) {
                    var acumulado = 0.dp
                    detectHorizontalDragGestures(
                        onDragStart = { acumulado = atual }
                    ) { change, dx ->
                        change.consume()
                        acumulado += dx.toDp()
                        ajustar(acumulado)
                    }
                },
            contentAlignment = Alignment.Center
        ) {
            Box(Modifier.width(2.dp).height(16.dp).background(PortalCores.CinzaTexto.copy(alpha = 0.45f), RoundedCornerShape(1.dp)))
        }
    }
}

@Composable
private fun BarraNavHorizontal(state: androidx.compose.foundation.ScrollState, vista: Int) {
    val max = state.maxValue
    if (vista <= 0 || max <= 0) return
    val scope = rememberCoroutineScope()
    val density = LocalDensity.current
    var trilho by remember { mutableIntStateOf(0) }
    var arrastando by remember { mutableStateOf(false) }
    val passo = (vista * 0.75f).roundToInt().coerceAtLeast(80)
    Row(
        Modifier.fillMaxWidth().padding(horizontal = 6.dp, vertical = 4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        TextButton(onClick = { scope.launch { state.animateScrollTo((state.value - passo).coerceAtLeast(0)) } }, enabled = state.canScrollBackward) {
            androidx.compose.material3.Icon(Icons.Filled.KeyboardArrowLeft, contentDescription = "Ver colunas à esquerda", tint = PortalCores.Navy)
        }
        Box(
            Modifier
                .weight(1f)
                .height(12.dp)
                .clip(RoundedCornerShape(50))
                .background(Color(0x14000000))
                .onSizeChanged { trilho = it.width }
                .pointerInput(max, trilho, vista) {
                    detectHorizontalDragGestures(
                        onDragStart = { arrastando = true },
                        onDragEnd = { arrastando = false },
                        onDragCancel = { arrastando = false }
                    ) { change, dx ->
                        change.consume()
                        val minimo = with(density) { 36.dp.toPx() }
                        val total = vista + max
                        val thumb = if (trilho > 0) kotlin.math.max(trilho * (vista.toFloat() / total), minimo).coerceAtMost(trilho.toFloat()) else 1f
                        val curso = (trilho - thumb).coerceAtLeast(1f)
                        state.dispatchRawDelta(dx * (max / curso))
                    }
                }
        ) {
            if (trilho > 0) {
                val minimo = with(density) { 36.dp.toPx() }
                val total = vista + max.toFloat()
                val thumb = kotlin.math.max(trilho * (vista / total), minimo).coerceAtMost(trilho.toFloat())
                val curso = (trilho - thumb).coerceAtLeast(1f)
                val progresso = (state.value / max.toFloat()).coerceIn(0f, 1f)
                Box(
                    Modifier
                        .offset { IntOffset((curso * progresso).roundToInt(), 0) }
                        .width(with(density) { thumb.toDp() })
                        .height(12.dp)
                        .clip(RoundedCornerShape(50))
                        .background(PortalCores.Navy.copy(alpha = if (arrastando) 0.7f else 0.4f))
                )
            }
        }
        TextButton(onClick = { scope.launch { state.animateScrollTo((state.value + passo).coerceAtMost(state.maxValue)) } }, enabled = state.canScrollForward) {
            androidx.compose.material3.Icon(Icons.Filled.KeyboardArrowRight, contentDescription = "Ver colunas à direita", tint = PortalCores.Navy)
        }
    }
}

@Composable
private fun TabelaColab(
    todos: List<Colaborador>,
    codigoPorId: Map<String, String>,
    regras: ColabRegras,
    hoje: Long,
    onAbrir: (String) -> Unit,
    acima: @Composable ColumnScope.() -> Unit
) {
    var ordemCol by remember { mutableStateOf("NOME") }
    var ordemAsc by remember { mutableStateOf(true) }
    fun ordenar(col: String) {
        if (ordemCol == col) ordemAsc = !ordemAsc else { ordemCol = col; ordemAsc = true }
    }
    fun cres(col: String): Boolean? = if (ordemCol == col) ordemAsc else null
    val lista = remember(todos, ordemCol, ordemAsc, regras, hoje, codigoPorId) {
        ordenarColab(todos, ordemCol, ordemAsc, regras, hoje, codigoPorId)
    }
    TabelaPortal(
        antes = acima,
        fixar = true,
        cabecalho = {
            CelulaCabecalhoOrdenavel("MTR", 0.6f, cres("MTR")) { ordenar("MTR") }
            CelulaCabecalhoOrdenavel("Colaborador", 2.3f, cres("NOME")) { ordenar("NOME") }
            CelulaCabecalhoOrdenavel("Função", 1.7f, cres("FUNCAO")) { ordenar("FUNCAO") }
            CelulaCabecalhoOrdenavel("Contrato", 0.7f, cres("VINCULO")) { ordenar("VINCULO") }
            CelulaCabecalhoOrdenavel("Situação", 1.1f, cres("SITUACAO")) { ordenar("SITUACAO") }
            CelulaCabecalhoOrdenavel("CC", 0.5f, cres("CC")) { ordenar("CC") }
            CelulaCabecalhoOrdenavel("Admissão", 0.9f, cres("ADMISSAO")) { ordenar("ADMISSAO") }
            CelulaCabecalhoOrdenavel("Nascimento", 0.9f, cres("NASCIMENTO")) { ordenar("NASCIMENTO") }
            CelulaCabecalhoOrdenavel("RG", 0.9f, cres("RG")) { ordenar("RG") }
            CelulaCabecalhoOrdenavel("CPF", 1.1f, cres("CPF")) { ordenar("CPF") }
            CelulaCabecalhoOrdenavel("Documentos", 1.0f, cres("DOCS")) { ordenar("DOCS") }
        }
    ) {
        lista.forEach { c ->
            LinhaTabela(onClick = { onAbrir(c.id) }) {
                Celula(c.matricula.ifBlank { "—" }, 0.6f, negrito = true, cor = PortalCores.Navy)
                Celula(c.nome + if (c.vinculo == "PJ") " (PJ)" else "", 2.3f, negrito = true)
                Celula(c.funcao.ifBlank { "—" }, 1.7f)
                Celula(c.vinculo.ifBlank { "—" }, 0.7f)
                Celula(c.situacao.ifBlank { "—" }, 1.1f, cor = if (c.desativado) PortalCores.CinzaClaro else PortalCores.Texto)
                Celula(codigoPorId[c.ccId].orEmpty().ifBlank { "—" }, 0.5f)
                Celula(c.admissao.ifBlank { "—" }, 0.9f)
                Celula(c.nascimento.ifBlank { "—" }, 0.9f)
                Celula(c.rg.ifBlank { "—" }, 0.9f)
                Celula(cpfMascarado(c.cpf), 1.1f)
                val pior = StatusColab.pior(c, regras, hoje)
                Box(Modifier.weight(1.0f)) { ChipCor(pior.rotulo, cor(pior)) }
            }
        }
    }
}

@Composable
private fun CartaoColabCompacto(c: Colaborador, codigoCc: String, regras: ColabRegras, hoje: Long, onClick: () -> Unit) {
    val pior = StatusColab.pior(c, regras, hoje)
    CartaoBranco(Modifier.fillMaxWidth().clickable { onClick() }) {
        Column(Modifier.padding(14.dp), verticalArrangement = Arrangement.spacedBy(3.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(c.nome, Modifier.weight(1f), color = PortalCores.Navy, fontWeight = FontWeight.Bold)
                ChipCor(pior.rotulo, cor(pior))
            }
            Text(
                listOf(c.matricula.takeIf { it.isNotBlank() }?.let { "MTR $it" }, c.funcao, c.vinculo, c.situacao, codigoCc.takeIf { it.isNotBlank() }?.let { "CC $it" })
                    .filter { !it.isNullOrBlank() }.joinToString(" · "),
                style = MaterialTheme.typography.bodySmall,
                color = PortalCores.CinzaTexto
            )
        }
    }
}

// ---------------------------------------------------------------- Vencimentos

private data class ItemVenc(val c: Colaborador, val key: String, val rotulo: String, val s: SituacaoDoc)

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun VencimentosColab(
    lista: List<Colaborador>,
    regras: ColabRegras,
    hoje: Long,
    largo: Boolean,
    statusInicial: String,
    onFiltroStatus: (String) -> Unit,
    onAbrir: (String) -> Unit,
    salvar: suspend (Colaborador, String) -> String?
) {
    var doc by remember { mutableStateOf("") }
    var periodo by remember { mutableStateOf(if (statusInicial.isBlank()) "60" else "TODOS") }
    var renovar by remember { mutableStateOf<ItemVenc?>(null) }
    val statusSel = statusInicial.takeIf { it.isNotBlank() }?.let { StatusDoc.valueOf(it) }
    val docsVenc = docsTela()
    val extrasVenc = ExtrasColabLocal.current
    val itens = remember(lista, regras, doc, periodo, statusInicial, docsVenc, extrasVenc) {
        lista.filter { it.noQuadro(DatasColab.isoDeDias(hoje)) }.flatMap { c ->
            docsVenc.filter { !it.marcacao && (doc.isBlank() || it.key == doc) }.mapNotNull { d ->
                val s = StatusColab.doc(c, d.key, regras, hoje)
                val dias = s.dias ?: return@mapNotNull null
                val noPeriodo = when (periodo) {
                    "VENCIDOS" -> dias < 0
                    "TODOS" -> true
                    else -> dias <= (periodo.toIntOrNull() ?: 60)
                }
                if (noPeriodo && (statusSel == null || s.status == statusSel)) ItemVenc(c, d.key, d.rotulo, s) else null
            } + (if (!extrasVenc) emptyList() else c.outros.filter { doc.isBlank() || doc == "OUTRO" }.mapNotNull { o ->
                val s = StatusColab.outro(o, regras, hoje)
                val dias = s.dias ?: return@mapNotNull null
                val noPeriodo = when (periodo) {
                    "VENCIDOS" -> dias < 0
                    "TODOS" -> true
                    else -> dias <= (periodo.toIntOrNull() ?: 60)
                }
                if (noPeriodo && (statusSel == null || s.status == statusSel)) ItemVenc(c, "OUTRO:${o.id}", o.nome, s) else null
            })
        }.sortedBy { it.s.dias }
    }
    CartaoSecao(
        "Vencimentos",
        subtitulo = "${itens.size} documento(s) · registre a renovação direto na linha",
        acoes = { OutlinedButton(onClick = { exportarVencimentos(itens) }) { Text("Exportar (Excel)") } }
    ) {
        val filtrosVenc: @Composable ColumnScope.() -> Unit = {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                val w = if (largo) Modifier.width(230.dp) else Modifier.fillMaxWidth()
                Seletor(
                    "Documento",
                    listOf("" to "Todos") + docsVenc.filter { !it.marcacao }.map { it.key to it.rotulo } +
                        (if (extrasVenc) listOf("OUTRO" to "Outros") else emptyList()),
                    doc,
                    { doc = it },
                    w
                )
                Seletor(
                    "Período",
                    listOf("VENCIDOS" to "Já vencidos", "30" to "Até 30 dias", "60" to "Até 60 dias", "90" to "Até 90 dias", "TODOS" to "Todos"),
                    periodo,
                    { periodo = it },
                    w
                )
                Seletor(
                    "Status",
                    listOf("" to "Qualquer") + listOf(StatusDoc.VENCIDO, StatusDoc.CRITICO, StatusDoc.ATENCAO, StatusDoc.VALIDO).map { it.name to it.rotulo },
                    statusInicial,
                    onFiltroStatus,
                    w
                )
            }
        }
        if (itens.isEmpty()) {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { filtrosVenc() } }
            Text("Nenhum vencimento com esses filtros.", color = PortalCores.CinzaTexto)
        } else {
            val ordem = rememberOrdem("VENC")
            val linhas = ordem.aplicar(itens) {
                when (ordem.col) {
                    "FUNCAO" -> it.c.funcao
                    "DOC" -> it.rotulo
                    "REAL" -> it.s.realizado.orEmpty()
                    "PRAZO" -> (it.s.dias ?: 0).toString().padStart(6, '0')
                    "STATUS" -> it.s.status.rotulo
                    "VENC" -> it.s.vencimento.orEmpty()
                    else -> it.c.nome
                }
            }
            TabelaPortal(
                antes = filtrosVenc,
                fixar = true,
                cabecalho = {
                    CelulaCabecalhoOrdenavel("Colaborador", 2.2f, ordem.marca("NOME")) { ordem.clique("NOME") }
                    if (largo) CelulaCabecalhoOrdenavel("Função", 1.5f, ordem.marca("FUNCAO")) { ordem.clique("FUNCAO") }
                    CelulaCabecalhoOrdenavel("Documento", 0.9f, ordem.marca("DOC")) { ordem.clique("DOC") }
                    if (largo) CelulaCabecalhoOrdenavel("Realizado", 0.9f, ordem.marca("REAL")) { ordem.clique("REAL") }
                    CelulaCabecalhoOrdenavel("Vencimento", 1.0f, ordem.marca("VENC")) { ordem.clique("VENC") }
                    if (largo) CelulaCabecalhoOrdenavel("Prazo", 1.2f, ordem.marca("PRAZO")) { ordem.clique("PRAZO") }
                    CelulaCabecalhoOrdenavel("Status", 0.9f, ordem.marca("STATUS")) { ordem.clique("STATUS") }
                    CelulaCabecalho("", 0.9f)
                }
            ) {
                linhas.forEach { it ->
                    LinhaTabela(onClick = { onAbrir(it.c.id) }) {
                        Celula(it.c.nome, 2.2f, negrito = true)
                        if (largo) Celula(it.c.funcao, 1.5f, cor = PortalCores.CinzaTexto)
                        Celula(it.rotulo, 0.9f)
                        if (largo) Celula(br(it.s.realizado), 0.9f)
                        Celula(br(it.s.vencimento), 1.0f, negrito = true, cor = cor(it.s.status))
                        if (largo) Celula(textoDias(it.s.dias), 1.2f, cor = PortalCores.CinzaTexto)
                        Box(Modifier.weight(0.9f)) { ChipCor(it.s.status.rotulo, cor(it.s.status)) }
                        Box(Modifier.weight(0.9f)) {
                            if (!SoVerColabLocal.current) TextButton(onClick = { renovar = it }) { Text("Renovar") }
                        }
                    }
                }
            }
        }
    }
    renovar?.let { item ->
        RenovarDialog(item, onFechar = { renovar = null }, salvar = salvar)
    }
}

@Composable
private fun RenovarDialog(item: ItemVenc, onFechar: () -> Unit, salvar: suspend (Colaborador, String) -> String?) {
    val scope = rememberCoroutineScope()
    var data by remember { mutableStateOf(DateInputMask.now(DateFieldKind.DATE)) }
    var erro by remember { mutableStateOf<String?>(null) }
    var salvando by remember { mutableStateOf(false) }
    AlertDialog(
        onDismissRequest = { if (!salvando) onFechar() },
        title = { Text("Registrar renovação — ${item.rotulo}") },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
                Text(item.c.nome, fontWeight = FontWeight.SemiBold)
                Text("Realizado em ${br(item.s.realizado)} · vence ${br(item.s.vencimento)}", color = PortalCores.CinzaTexto)
                AppDateTextField(
                    value = data,
                    onValueChange = { data = it },
                    label = if (item.key.startsWith("OUTRO:")) "Nova validade" else "Nova data de realização"
                )
                erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
            }
        },
        confirmButton = {
            Button(
                enabled = !salvando,
                onClick = {
                    val iso = DatasColab.entradaParaIso(data)
                    if (iso.isBlank()) {
                        erro = "Informe a data (dd/mm/aaaa)."
                        return@Button
                    }
                    salvando = true
                    scope.launch {
                        val atualizado = if (item.key.startsWith("OUTRO:")) {
                            val id = item.key.removePrefix("OUTRO:")
                            item.c.copy(outros = item.c.outros.map { if (it.id == id) it.copy(validade = iso) else it })
                        } else {
                            item.c.copy(docs = item.c.docs + (item.key to iso))
                        }
                        val r = salvar(atualizado, "Renovação ${item.rotulo}")
                        salvando = false
                        if (r == null) onFechar() else erro = r
                    }
                }
            ) { Text(if (salvando) "Salvando..." else "Salvar") }
        },
        dismissButton = { TextButton(onClick = onFechar, enabled = !salvando) { Text("Cancelar") } }
    )
}

private fun exportarVencimentos(itens: List<ItemVenc>) {
    fun cel(s: String) = "\"" + s.replace("\"", "\"\"") + "\""
    val linhas = listOf(listOf("Colaborador", "Vínculo", "Função", "Documento", "Realizado", "Vencimento", "Dias", "Status")) +
        itens.map {
            listOf(
                it.c.nome, it.c.vinculo, it.c.funcao, it.rotulo, DatasColab.isoParaBr(it.s.realizado),
                DatasColab.isoParaBr(it.s.vencimento), it.s.dias?.toString().orEmpty(), it.s.status.rotulo
            )
        }
    val csv = linhas.joinToString("\r\n") { l -> l.joinToString(";") { cel(it) } }
    val path = PlatformFiles.join(PlatformFiles.cacheDir(), "vencimentos-qsms.csv")
    PlatformFiles.writeBytes(path, "\uFEFF".encodeToByteArray() + csv.encodeToByteArray())
    PlatformFiles.shareFile(path, "text/csv", "Vencimentos QSMS")
}

// ---------------------------------------------------------------- CNH

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun CnhColab(
    lista: List<Colaborador>,
    regras: ColabRegras,
    hoje: Long,
    largo: Boolean,
    onAbrir: (String) -> Unit,
    salvar: suspend (Colaborador, String) -> String?
) {
    var grupo by remember { mutableStateOf("POSSUEM") }
    var editar by remember { mutableStateOf<Colaborador?>(null) }
    val ativos = lista.filter { it.noQuadro(DatasColab.isoDeDias(hoje)) }
    val grupos = listOf(
        "POSSUEM" to "Possuem",
        "SEM_VALIDADE" to "Sem validade",
        "VENCENDO" to "Vencendo",
        "VENCIDAS" to "Vencidas",
        "VERIFICAR" to "A verificar",
        "TODOS" to "Todos"
    )
    fun noGrupo(c: Colaborador, g: String): Boolean {
        val s = StatusColab.cnh(c, regras, hoje).status
        return when (g) {
            "POSSUEM" -> c.cnh.aplica == "sim"
            "SEM_VALIDADE" -> s == StatusDoc.PENDENTE
            "VENCENDO" -> s == StatusDoc.CRITICO || s == StatusDoc.ATENCAO
            "VENCIDAS" -> s == StatusDoc.VENCIDO
            "VERIFICAR" -> s == StatusDoc.VERIFICAR
            else -> true
        }
    }
    val itens = ativos.filter { noGrupo(it, grupo) }
    val gruposUi: @Composable ColumnScope.() -> Unit = {
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            grupos.forEach { (g, rot) ->
                val sel = g == grupo
                Text(
                    "$rot (${ativos.count { noGrupo(it, g) }})",
                    color = if (sel) Color.White else PortalCores.Navy,
                    modifier = Modifier
                        .background(if (sel) PortalCores.Marca else PortalCores.Cartao, RoundedCornerShape(10.dp))
                        .border(1.dp, if (sel) PortalCores.Marca else PortalCores.Borda, RoundedCornerShape(10.dp))
                        .clickable { grupo = g }
                        .padding(horizontal = 12.dp, vertical = 7.dp)
                )
            }
        }
    }
    CartaoSecao("CNH", subtitulo = "Colaboradores ativos · clique na linha para editar a CNH") {
        if (itens.isEmpty()) {
            PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { gruposUi() } }
            Text("Ninguém neste grupo.", color = PortalCores.CinzaTexto)
        } else {
            val ordem = rememberOrdem("NOME")
            val linhas = ordem.aplicar(itens) { c ->
                val s = StatusColab.cnh(c, regras, hoje)
                when (ordem.col) {
                    "FUNCAO" -> c.funcao
                    "APLICA" -> c.cnh.aplica
                    "CAT" -> c.cnh.categoria
                    "VAL" -> c.cnh.validade
                    "EAR" -> if (c.cnh.ear) "1" else "0"
                    "STATUS" -> s.status.rotulo
                    else -> c.nome
                }
            }
            TabelaPortal(
                antes = gruposUi,
                fixar = true,
                cabecalho = {
                    CelulaCabecalhoOrdenavel("Colaborador", 2.2f, ordem.marca("NOME")) { ordem.clique("NOME") }
                    if (largo) CelulaCabecalhoOrdenavel("Função", 1.6f, ordem.marca("FUNCAO")) { ordem.clique("FUNCAO") }
                    CelulaCabecalhoOrdenavel("Aplica", 0.7f, ordem.marca("APLICA")) { ordem.clique("APLICA") }
                    CelulaCabecalhoOrdenavel("Cat.", 0.6f, ordem.marca("CAT")) { ordem.clique("CAT") }
                    CelulaCabecalhoOrdenavel("Validade", 1.0f, ordem.marca("VAL")) { ordem.clique("VAL") }
                    if (largo) CelulaCabecalhoOrdenavel("EAR", 0.5f, ordem.marca("EAR")) { ordem.clique("EAR") }
                    CelulaCabecalhoOrdenavel("Status", 1.1f, ordem.marca("STATUS")) { ordem.clique("STATUS") }
                }
            ) {
                linhas.forEach { c ->
                    val s = StatusColab.cnh(c, regras, hoje)
                    LinhaTabela(onClick = { editar = c }) {
                        Celula(c.nome, 2.2f, negrito = true)
                        if (largo) Celula(c.funcao, 1.6f, cor = PortalCores.CinzaTexto)
                        Celula(when (c.cnh.aplica) { "sim" -> "Sim"; "nao" -> "Não"; else -> "—" }, 0.7f)
                        Celula(c.cnh.categoria.ifBlank { "—" }, 0.6f)
                        Celula(br(c.cnh.validade), 1.0f)
                        if (largo) Celula(if (c.cnh.ear) "Sim" else "—", 0.5f)
                        Box(Modifier.weight(1.1f)) { ChipCor(s.status.rotulo, cor(s.status)) }
                    }
                }
            }
        }
    }
    editar?.let { c ->
        CnhDialog(c, onFechar = { editar = null }, onFicha = { editar = null; onAbrir(c.id) }, salvar = salvar)
    }
}

@Composable
private fun CnhDialog(c: Colaborador, onFechar: () -> Unit, onFicha: () -> Unit, salvar: suspend (Colaborador, String) -> String?) {
    val scope = rememberCoroutineScope()
    var cnh by remember { mutableStateOf(c.cnh) }
    var validade by remember { mutableStateOf(DatasColab.isoParaBr(c.cnh.validade)) }
    var erro by remember { mutableStateOf<String?>(null) }
    var salvando by remember { mutableStateOf(false) }
    AlertDialog(
        onDismissRequest = { if (!salvando) onFechar() },
        title = { Text("CNH — ${c.nome}") },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
                CamposCnh(cnh, validade, onCnh = { cnh = it }, onValidade = { validade = it })
                TextButton(onClick = onFicha) { Text("Abrir ficha completa") }
                erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
            }
        },
        confirmButton = {
            Button(enabled = !salvando, onClick = {
                val iso = DatasColab.entradaParaIso(validade)
                if (validade.any { it.isDigit() } && iso.isBlank()) {
                    erro = "Validade inválida (dd/mm/aaaa)."
                    return@Button
                }
                salvando = true
                scope.launch {
                    val r = salvar(c.copy(cnh = cnh.copy(validade = iso)), "CNH atualizada")
                    salvando = false
                    if (r == null) onFechar() else erro = r
                }
            }) { Text(if (salvando) "Salvando..." else "Salvar") }
        },
        dismissButton = { TextButton(onClick = onFechar, enabled = !salvando) { Text("Cancelar") } }
    )
}

@Composable
private fun CamposCnh(cnh: CnhDados, validade: String, onCnh: (CnhDados) -> Unit, onValidade: (String) -> Unit) {
    Seletor("Possui CNH?", listOf("" to "Não informado", "sim" to "Sim", "nao" to "Não se aplica"), cnh.aplica, { onCnh(cnh.copy(aplica = it)) })
    if (cnh.aplica == "sim") {
        Seletor("Categoria", DocsMatriz.cnhCategorias.map { it to it.ifBlank { "—" } }, cnh.categoria, { onCnh(cnh.copy(categoria = it)) })
        Campo("Número da CNH", cnh.numero, numero = true) { v -> onCnh(cnh.copy(numero = v.filter { it.isDigit() }.take(20))) }
        AppDateTextField(value = validade, onValueChange = onValidade, label = "Validade")
        Row(verticalAlignment = Alignment.CenterVertically) {
            Checkbox(checked = cnh.ear, onCheckedChange = { onCnh(cnh.copy(ear = it)) })
            Text("EAR (exerce atividade remunerada)")
        }
    }
}

// ---------------------------------------------------------------- Pendências

@Composable
private fun PendenciasColab(lista: List<Colaborador>, regras: ColabRegras, hoje: Long, onAbrir: (String) -> Unit) {
    val ativos = lista.filter { it.noQuadro(DatasColab.isoDeDias(hoje)) }
    val obrig = ativos.mapNotNull { c ->
        val docs = docsTela().filter { StatusColab.doc(c, it.key, regras, hoje).status == StatusDoc.PENDENTE }.map { it.rotulo }
        if (docs.isEmpty()) null else c to docs
    }
    CartaoSecao("Obrigatórios sem registro", subtitulo = "${obrig.size} colaborador(es) ativo(s)") {
        if (obrig.isEmpty()) Text("Nenhuma pendência de documento obrigatório.", color = PortalCores.Verde)
        obrig.forEach { (c, docs) ->
            Row(
                Modifier.fillMaxWidth().clickable { onAbrir(c.id) }.padding(vertical = 4.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(Modifier.weight(1f)) {
                    Text(c.nome, color = PortalCores.Texto, fontWeight = FontWeight.SemiBold)
                    Text(c.funcao, style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                }
                Text(docs.joinToString(", "), color = cor(StatusDoc.PENDENTE), fontWeight = FontWeight.SemiBold, modifier = Modifier.widthIn(max = 360.dp))
            }
            HorizontalDivider(color = PortalCores.Borda)
        }
    }

    val nomes = lista.groupBy { "${it.vinculo}|${norm(it.nome)}" }.filterValues { it.size > 1 }.values.flatten().map { it.id }.toSet()
    val verificacoes = buildList {
        ativos.forEach { c ->
            val d = Cpf.digitos(c.cpf)
            if (d.isEmpty()) add(c to "Sem CPF")
            else if (!Cpf.valido(d)) add(c to "CPF inválido")
            if (c.situacao.isBlank()) add(c to "Situação não informada")
            if (c.admissao.isBlank()) add(c to "Sem data de admissão")
            if (StatusColab.cnh(c, regras, hoje).status == StatusDoc.VERIFICAR) add(c to "CNH não informada (função de condução)")
        }
        lista.filter { it.id in nomes }.forEach { add(it to "Nome repetido no mesmo vínculo") }
        lista.filter { it.foraMatriz }.forEach { add(it to "Fora da matriz importada (revisar)") }
    }
    CartaoSecao("Verificações de cadastro", subtitulo = "${verificacoes.size} item(ns)") {
        if (verificacoes.isEmpty()) Text("Cadastro sem inconsistências.", color = PortalCores.Verde)
        verificacoes.forEach { (c, motivo) ->
            Row(
                Modifier.fillMaxWidth().clickable { onAbrir(c.id) }.padding(vertical = 4.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(c.nome, Modifier.weight(1f), color = PortalCores.Texto)
                ChipCor(motivo, PortalCores.Laranja)
            }
        }
    }
}

// ---------------------------------------------------------------- Regras

@Composable
private fun RegrasColab(regras: ColabRegras, master: Boolean, salvar: suspend (ColabRegras) -> String?) {
    val scope = rememberCoroutineScope()
    var r by remember(regras) { mutableStateOf(regras) }
    var erro by remember { mutableStateOf<String?>(null) }
    var salvando by remember { mutableStateOf(false) }
    fun num(s: String): Int? = s.filter { it.isDigit() }.take(4).toIntOrNull()
    CartaoSecao(
        "Janelas de alerta",
        subtitulo = if (master) "Dias antes do vencimento" else "Somente administradores alteram as regras"
    ) {
        Par(
            true,
            { m -> Campo("Crítico (dias)", r.crit.toString(), numero = true, somenteLeitura = !master, modifier = m) { v -> num(v)?.let { r = r.copy(crit = it) } } },
            { m -> Campo("Atenção (dias)", r.aten.toString(), numero = true, somenteLeitura = !master, modifier = m) { v -> num(v)?.let { r = r.copy(aten = it) } } }
        )
        Par(
            true,
            { m -> Campo("CNH crítico (dias)", r.cnhCrit.toString(), numero = true, somenteLeitura = !master, modifier = m) { v -> num(v)?.let { r = r.copy(cnhCrit = it) } } },
            { m -> Campo("CNH atenção (dias)", r.cnhAten.toString(), numero = true, somenteLeitura = !master, modifier = m) { v -> num(v)?.let { r = r.copy(cnhAten = it) } } }
        )
    }
    CartaoSecao("Validade e obrigatoriedade por documento", subtitulo = "Validade em dias contados da data de realização; vazio = não vence") {
        TabelaPortal(
            cabecalho = {
                CelulaCabecalho("Documento", 2.4f)
                CelulaCabecalho("Obrigatório", 1.0f)
                CelulaCabecalho("Validade CLT", 1.2f)
                CelulaCabecalho("Validade PJ", 1.2f)
            }
        ) {
            docsTela().forEach { doc ->
                val dr = r.doc(doc.key)
                fun set(n: RegraDoc) {
                    r = r.copy(docs = r.docs + (doc.key to n))
                }
                LinhaTabela {
                    Column(Modifier.weight(2.4f)) {
                        Text(doc.rotulo, fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
                        Text(doc.descricao, style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                    }
                    Box(Modifier.weight(1.0f)) {
                        Checkbox(checked = dr.obrig, enabled = master, onCheckedChange = { set(dr.copy(obrig = it)) })
                    }
                    if (doc.marcacao) {
                        Celula("só marcação (OK)", 2.4f, cor = PortalCores.CinzaTexto)
                    } else {
                        Box(Modifier.weight(1.2f).padding(end = 8.dp)) {
                            Campo("dias", dr.valCLT?.toString().orEmpty(), numero = true, somenteLeitura = !master) { set(dr.copy(valCLT = num(it))) }
                        }
                        Box(Modifier.weight(1.2f)) {
                            Campo("dias", dr.valPJ?.toString().orEmpty(), numero = true, somenteLeitura = !master) { set(dr.copy(valPJ = num(it))) }
                        }
                    }
                }
            }
        }
        erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
        if (master) {
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                Button(enabled = !salvando && r != regras, onClick = {
                    salvando = true
                    scope.launch {
                        erro = salvar(r)
                        salvando = false
                    }
                }) { Text(if (salvando) "Salvando..." else "Salvar regras") }
                OutlinedButton(enabled = r != regras, onClick = { r = regras }) { Text("Desfazer") }
            }
        }
    }
}

// ---------------------------------------------------------------- Backup

@Composable
private fun BackupColab(d: ColabDados, largo: Boolean, onAviso: (String) -> Unit, onRecarregar: () -> Unit) {
    val scope = rememberCoroutineScope()
    var importando by remember { mutableStateOf(false) }
    var pendente by remember { mutableStateOf<Pair<String, Int>?>(null) }
    var resultado by remember { mutableStateOf<String?>(null) }
    val baixar: @Composable (Modifier) -> Unit = { m ->
        CartaoSecao("Baixar backup", m, subtitulo = "Arquivo JSON no mesmo formato do portal antigo (pode ser reimportado)") {
            Text("${d.colaboradores.size} colaboradores e as regras de validade.", color = PortalCores.CinzaTexto)
            Button(onClick = {
                val agora = formatDateTimeBr(currentTimeMillis())
                val json = ColaboradoresApi.backupJson(d, agora)
                val nome = "Backup_Colaboradores_QSMS_${formatDateBr(currentTimeMillis()).substringBefore(' ').replace('/', '-')}.json"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), nome)
                PlatformFiles.writeText(path, json)
                PlatformFiles.shareFile(path, "application/json", "Backup colaboradores")
            }) { Text("Baixar backup (.json)") }
        }
    }
    val importar: @Composable (Modifier) -> Unit = { m ->
        CartaoSecao("Importar matriz", m, subtitulo = "Mescla com o cadastro: casa por CPF + vínculo e depois pelo nome") {
            if (!d.master) {
                Text("Somente o admin master importa a matriz.", color = PortalCores.CinzaTexto)
            } else {
                Text(
                    "Quem já está no cadastro é atualizado; quem é novo entra; quem não está no arquivo fica como está, marcado como \"fora da matriz\". " +
                        "Campo vazio no arquivo não apaga CPF, admissão, matrícula nem função já cadastrados.",
                    style = MaterialTheme.typography.bodySmall,
                    color = PortalCores.CinzaTexto
                )
                Button(enabled = !importando, onClick = {
                    scope.launch {
                        val arq = PlatformServices.pickJson() ?: return@launch
                        val texto = arq.bytes.decodeToString()
                        val qtd = Regex("\"nome\"\\s*:").findAll(texto).count()
                        if (!texto.contains("\"colaboradores\"") || qtd == 0) {
                            onAviso("Arquivo sem a lista de colaboradores.")
                        } else {
                            pendente = texto to qtd
                        }
                    }
                }) { Text(if (importando) "Importando..." else "Escolher arquivo (.json)") }
                resultado?.let { Text(it, color = PortalCores.Verde) }
            }
        }
    }
    if (largo) {
        Row(horizontalArrangement = Arrangement.spacedBy(18.dp), verticalAlignment = Alignment.Top) {
            baixar(Modifier.weight(1f))
            importar(Modifier.weight(1f))
        }
    } else {
        baixar(Modifier.fillMaxWidth())
        importar(Modifier.fillMaxWidth())
    }
    pendente?.let { (texto, qtd) ->
        AlertDialog(
            onDismissRequest = { pendente = null },
            title = { Text("Importar matriz?") },
            text = { Text("O arquivo tem cerca de $qtd colaboradores. A importação mescla com o cadastro atual e fica registrada no log.") },
            confirmButton = {
                Button(onClick = {
                    pendente = null
                    importando = true
                    scope.launch {
                        ColaboradoresApi.importar(texto)
                            .onSuccess {
                                resultado = "Importação concluída: ${it.atualizados} atualizados, ${it.inseridos} novos, " +
                                    "${it.foraDaMatriz} fora da matriz, ${it.repetidos} linha(s) repetida(s) ignorada(s)" +
                                    if (it.rejeitados.isNotEmpty()) ", ${it.rejeitados.size} rejeitada(s): ${it.rejeitados.take(5).joinToString("; ")}" else "."
                                onRecarregar()
                            }
                            .onFailure { onAviso(it.message ?: "Falha ao importar.") }
                        importando = false
                    }
                }) { Text("Importar") }
            },
            dismissButton = { TextButton(onClick = { pendente = null }) { Text("Cancelar") } }
        )
    }
}

// ---------------------------------------------------------------- Ficha

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun FichaColab(
    controller: AppController,
    centros: List<CentroColab>,
    c: Colaborador,
    regras: ColabRegras,
    hoje: Long,
    podeEditar: Boolean,
    podeExcluir: Boolean,
    onFechar: () -> Unit,
    onEditar: () -> Unit,
    salvar: suspend (Colaborador, String) -> String?,
    onExcluir: () -> Unit
) {
    val scope = rememberCoroutineScope()
    var mostrarCpf by remember { mutableStateOf(false) }
    var confirmarExclusao by remember { mutableStateOf(false) }
    var erro by remember { mutableStateOf<String?>(null) }
    var gerar by remember { mutableStateOf<String?>(null) }
    var anexos by remember(c.id) { mutableStateOf<List<FuncionarioDocumento>>(emptyList()) }
    var removerAnexo by remember { mutableStateOf<FuncionarioDocumento?>(null) }
    var anexandoChave by remember { mutableStateOf<String?>(null) }
    val ccNome = centros.firstOrNull { it.id == c.ccId }?.rotulo ?: c.ccId
    val versaoDocs by controller.documentosVersao.collectAsState()
    val abrindoId by controller.abrindoDocumentoId.collectAsState()
    LaunchedEffect(c.id, versaoDocs) {
        FuncionariosApi.documentos(c.id)
            .onSuccess { anexos = it; erro = null }
            .onFailure { erro = it.message ?: "Falha ao carregar os arquivos anexos." }
    }
    val podeGerarDoc = PodeGerarDocLocal.current
    fun anexarNaFicha(chaveUi: String, tipo: String, titulo: String) {
        if (c.id.isBlank() || anexandoChave != null) return
        scope.launch {
            anexandoChave = chaveUi
            erro = null
            runCatching {
                val arq = PlatformServices.pickDocument() ?: return@runCatching
                FuncionariosApi.enviarDocumento(c.id, arq.bytes, tipo, titulo, arq.name, false)
                    .onSuccess {
                        anexos = anexos + it
                        controller.notificarDocumentosAlterados()
                    }
                    .onFailure { erro = it.message ?: "Falha ao anexar." }
            }.onFailure { erro = it.message ?: "Falha ao anexar." }
            anexandoChave = null
        }
    }
    fun pessoa() = Funcionario(
        id = c.id, nome = c.nome, cpf = c.cpf, admissao = c.admissao, matricula = c.matricula,
        cargoId = c.cargoId, cargoNome = c.funcao, setorGhe = c.setorGhe, vinculo = c.vinculo,
        situacao = c.situacao, nascimento = c.nascimento, rg = c.rg,
        totalDocumentos = c.totalDocumentos, updatedAt = c.updatedAt
    )
    PortalModal(onFechar = onFechar, larguraMax = 860.dp) {
        CartaoBranco(Modifier.fillMaxWidth()) {
            Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.weight(1f)) {
                        Text(c.nome, color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.headlineSmall)
                        Text(c.funcao.ifBlank { "Função não informada" }, color = PortalCores.CinzaTexto)
                    }
                    TextButton(onClick = onFechar) { Text("Fechar") }
                    if (podeEditar) Button(onClick = onEditar) { Text("Editar") }
                }
                FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                    ChipCor(c.vinculo, PortalCores.AzulIcone)
                    ChipCor(c.situacao.ifBlank { "SITUAÇÃO NÃO INFORMADA" }, if (c.elegivel) PortalCores.Verde else PortalCores.CinzaClaro)
                    if (c.foraMatriz) ChipCor("Fora da matriz", PortalCores.Laranja)
                    if (ExtrasColabLocal.current && c.totalDocumentos > 0) ChipCor("${c.totalDocumentos} arquivo(s) na Emissão de Documentos", PortalCores.CinzaTexto)
                }
                SecaoFicha("Dados") {
                    FlowRow(horizontalArrangement = Arrangement.spacedBy(22.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                        Dado("Matrícula (MTR)", c.matricula)
                        Dado("Função", c.funcao)
                        Dado("Centro de custo", ccNome)
                        Dado("Setor/GHE", c.setorGhe)
                        Dado("Admissão", c.admissao)
                        Dado("Nascimento", c.nascimento + (DatasColab.idade(c.nascimento)?.let { " ($it anos)" } ?: ""))
                        Dado("RG", c.rg)
                        Column {
                            Text("CPF", style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaTexto)
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Text(if (mostrarCpf) Cpf.formatar(c.cpf).ifBlank { "—" } else cpfMascarado(c.cpf), color = PortalCores.Texto)
                                if (c.cpf.isNotBlank()) {
                                    TextButton(onClick = { mostrarCpf = !mostrarCpf }) { Text(if (mostrarCpf) "ocultar" else "mostrar") }
                                }
                            }
                        }
                        if (c.vinculo == "PJ" || c.cnpj.isNotBlank()) Dado("CNPJ", c.cnpj)
                        if (c.ctps.isNotBlank()) Dado("CTPS", c.ctps)
                        Dado("Dir. Def.", c.dirdef)
                        if (c.capacitacao.isNotBlank()) Dado("Capacitação", c.capacitacao)
                    }
                }
                SecaoFicha("CNH") {
                    val s = StatusColab.cnh(c, regras, hoje)
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(
                            when (c.cnh.aplica) {
                                "sim" -> listOf(
                                    "Categoria ${c.cnh.categoria.ifBlank { "—" }}",
                                    "validade ${br(c.cnh.validade)}",
                                    if (c.cnh.ear) "EAR" else ""
                                ).filter { it.isNotBlank() }.joinToString(" · ")
                                else -> s.texto
                            },
                            Modifier.weight(1f),
                            color = PortalCores.Texto
                        )
                        ChipCor(s.status.rotulo, cor(s.status))
                    }
                }
                SecaoFicha("Documentos") {
                    TabelaPortal(
                        cabecalho = {
                            CelulaCabecalho("Documento", 1.8f)
                            CelulaCabecalho("Realizado", 0.8f)
                            CelulaCabecalho("Vencimento", 0.8f)
                            CelulaCabecalho("Status", 2.2f)
                        }
                    ) {
                        docsTela().forEach { doc ->
                            val s = StatusColab.doc(c, doc.key, regras, hoje)
                            val arquivos = anexos.filter { anexoDoDocumento(it, doc) }
                            LinhaTabela {
                                Column(Modifier.weight(1.8f)) {
                                    Text(doc.rotulo, fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
                                    Text(doc.descricao, style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                                }
                                Celula(if (doc.marcacao) c.docs[doc.key] ?: "—" else br(s.realizado), 0.8f)
                                Celula(br(s.vencimento), 0.8f, cor = cor(s.status))
                                Column(Modifier.weight(2.2f)) {
                                    ChipCor(s.status.rotulo, cor(s.status))
                                    arquivos.forEach { arq ->
                                        Text(arq.fileName.ifBlank { arq.titulo }, style = MaterialTheme.typography.bodySmall, maxLines = 1)
                                        Row {
                                            TextButton(
                                                onClick = { controller.abrirDocumentoFuncionario(arq) },
                                                enabled = abrindoId == null
                                            ) { Text(if (abrindoId == arq.id) "..." else "Visualizar") }
                                            TextButton(onClick = {
                                                scope.launch {
                                                    FuncionariosApi.baixar(arq.id).onSuccess { bytes ->
                                                        val path = PlatformFiles.join(PlatformFiles.cacheDir(), arq.fileName.ifBlank { "documento" })
                                                        PlatformFiles.writeBytes(path, bytes)
                                                        PlatformFiles.shareFile(path, arq.contentType.ifBlank { "application/octet-stream" }, arq.fileName)
                                                    }.onFailure { erro = it.message }
                                                }
                                            }) { Text("Baixar") }
                                            TextButton(onClick = { removerAnexo = arq }) { Text("Excluir") }
                                        }
                                    }
                                    if (arquivos.isEmpty()) {
                                        Text(
                                            "Sem arquivo anexado",
                                            style = MaterialTheme.typography.bodySmall,
                                            color = PortalCores.CinzaTexto
                                        )
                                    }
                                    Row {
                                        TextButton(
                                            enabled = c.id.isNotBlank() && anexandoChave == null,
                                            onClick = {
                                                anexarNaFicha(
                                                    doc.key,
                                                    tipoAnexoMatriz(doc.key),
                                                    doc.rotulo
                                                )
                                            }
                                        ) {
                                            Text(
                                                when {
                                                    anexandoChave == doc.key -> "Anexando..."
                                                    else -> "Anexar"
                                                }
                                            )
                                        }
                                        if (podeGerarDoc(doc.key)) {
                                            TextButton(onClick = {
                                                val f = pessoa()
                                                when (doc.key) {
                                                    "OS" -> controller.preencherOs(f)
                                                    "EPI" -> controller.preencherFichaEpi(f)
                                                    else -> controller.preencherCertificado(f)
                                                }
                                                gerar = doc.key
                                            }) { Text("Gerar") }
                                        }
                                    }
                                }
                            }
                        }
                        if (ExtrasColabLocal.current) c.outros.forEach { extra ->
                            val s = StatusColab.outro(extra, regras, hoje)
                            val arquivos = anexos.filter { it.tipo == "OUTRO" && it.titulo.equals(extra.nome, ignoreCase = true) }
                            val chaveExtra = "OUTRO:${extra.id}"
                            LinhaTabela {
                                Column(Modifier.weight(1.8f)) {
                                    Text(extra.nome, fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
                                    Text("Documento personalizado", style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
                                }
                                Celula(br(s.realizado), 0.8f)
                                Celula(br(s.vencimento), 0.8f, cor = cor(s.status))
                                Column(Modifier.weight(2.2f)) {
                                    ChipCor(s.status.rotulo, cor(s.status))
                                    arquivos.forEach { arq ->
                                        Text(arq.fileName.ifBlank { arq.titulo }, style = MaterialTheme.typography.bodySmall, maxLines = 1)
                                        Row {
                                            TextButton(onClick = { controller.abrirDocumentoFuncionario(arq) }, enabled = abrindoId == null) {
                                                Text(if (abrindoId == arq.id) "..." else "Visualizar")
                                            }
                                            TextButton(onClick = {
                                                scope.launch {
                                                    FuncionariosApi.baixar(arq.id).onSuccess { bytes ->
                                                        val path = PlatformFiles.join(PlatformFiles.cacheDir(), arq.fileName.ifBlank { "documento" })
                                                        PlatformFiles.writeBytes(path, bytes)
                                                        PlatformFiles.shareFile(path, arq.contentType.ifBlank { "application/octet-stream" }, arq.fileName)
                                                    }.onFailure { erro = it.message }
                                                }
                                            }) { Text("Baixar") }
                                            TextButton(onClick = { removerAnexo = arq }) { Text("Excluir") }
                                        }
                                    }
                                    if (extra.nome.isNotBlank()) {
                                        TextButton(
                                            enabled = c.id.isNotBlank() && anexandoChave == null,
                                            onClick = {
                                                anexarNaFicha(chaveExtra, "OUTRO", extra.nome.trim())
                                            }
                                        ) {
                                            Text(if (anexandoChave == chaveExtra) "Anexando..." else "Anexar")
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (c.obs.isNotBlank()) SecaoFicha("Observações") { Text(c.obs, color = PortalCores.Texto) }
                if (ExtrasColabLocal.current) SecaoFicha("Documentos extras") {
                    FuncionarioDocumentosPanel(
                        controller,
                        Funcionario(
                            id = c.id,
                            nome = c.nome,
                            cpf = c.cpf,
                            admissao = c.admissao,
                            matricula = c.matricula,
                            cargoId = c.cargoId,
                            cargoNome = c.funcao,
                            setorGhe = c.setorGhe,
                            vinculo = c.vinculo,
                            situacao = c.situacao,
                            nascimento = c.nascimento,
                            rg = c.rg,
                            totalDocumentos = c.totalDocumentos,
                            updatedAt = c.updatedAt
                        ),
                        apenasExtras = true
                    )
                }
                if (c.hist.isNotEmpty()) {
                    SecaoFicha("Histórico") {
                        c.hist.forEach { h ->
                            Text(
                                "${formatDateTimeBr(h.t)} · ${h.by} · ${h.acao}" + if (h.campos.isNotEmpty()) ": ${h.campos.joinToString(", ")}" else "",
                                style = MaterialTheme.typography.bodySmall,
                                color = PortalCores.CinzaTexto
                            )
                        }
                    }
                }
                erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
                FlowRow(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    if (podeEditar) {
                    OutlinedButton(onClick = {
                        scope.launch {
                            val nova = if (c.desativado) "ATIVO" else "DESATIVADO"
                            erro = salvar(c.copy(situacao = nova), if (nova == "ATIVO") "Reativado" else "Desativado")
                        }
                    }) { Text(if (c.desativado) "Reativar" else "Desativar") }
                    }
                    if (podeExcluir) {
                        OutlinedButton(
                            onClick = { confirmarExclusao = true },
                            colors = ButtonDefaults.outlinedButtonColors(contentColor = PortalCores.Vermelho)
                        ) { Text("Excluir") }
                    }
                }
            }
        }
    }
    val chaveGerar = gerar
    if (chaveGerar != null) {
        PortalModal(onFechar = { gerar = null }, larguraMax = 980.dp) {
            CartaoBranco(Modifier.fillMaxWidth()) {
                Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(
                            when (chaveGerar) {
                                "OS" -> "Gerar Ordem de Serviço"
                                "EPI" -> "Gerar ficha de EPI"
                                else -> "Gerar certificado"
                            },
                            Modifier.weight(1f),
                            color = PortalCores.Navy,
                            fontWeight = FontWeight.Bold
                        )
                        TextButton(onClick = { gerar = null }) { Text("Fechar") }
                    }
                    when (chaveGerar) {
                        "OS" -> SharedOrdemServicoScreen(controller, embutido = true)
                        "EPI" -> SharedFichaEpiScreen(controller, embutido = true)
                        else -> SharedCertificadoScreen(controller, embutido = true, modeloInicial = modeloCertificado(chaveGerar))
                    }
                }
            }
        }
    }
    removerAnexo?.let { arq ->
        AlertDialog(
            onDismissRequest = { removerAnexo = null },
            title = { Text("Excluir anexo?") },
            text = { Text(arq.fileName.ifBlank { arq.titulo }) },
            confirmButton = {
                Button(
                    colors = ButtonDefaults.buttonColors(containerColor = PortalCores.Vermelho),
                    onClick = {
                        removerAnexo = null
                        scope.launch {
                            FuncionariosApi.remover(arq.id).onSuccess {
                                anexos = anexos.filter { it.id != arq.id }
                                controller.notificarDocumentosAlterados()
                            }.onFailure { erro = it.message }
                        }
                    }
                ) { Text("Excluir") }
            },
            dismissButton = { TextButton(onClick = { removerAnexo = null }) { Text("Cancelar") } }
        )
    }
    if (confirmarExclusao) {
        AlertDialog(
            onDismissRequest = { confirmarExclusao = false },
            title = { Text("Excluir ${c.nome}?") },
            text = { Text("O cadastro sai das listas (inclusive da Emissão de Documentos). Para só tirar dos indicadores, use Desativar.") },
            confirmButton = {
                Button(
                    colors = ButtonDefaults.buttonColors(containerColor = PortalCores.Vermelho),
                    onClick = {
                        confirmarExclusao = false
                        onExcluir()
                    }
                ) { Text("Excluir") }
            },
            dismissButton = { TextButton(onClick = { confirmarExclusao = false }) { Text("Cancelar") } }
        )
    }
}

private fun tipoAnexoMatriz(key: String): String = when (key) {
    "ASO" -> "ASO"
    "EPI" -> "FICHA_EPI"
    "OS" -> "OS"
    else -> "CERTIFICADO"
}

private fun anexoDoDocumento(d: FuncionarioDocumento, doc: DocMatriz): Boolean {
    val t = "${d.tipo} ${d.titulo} ${d.fileName}".uppercase()
    return when (doc.key) {
        "ASO" -> d.tipo == "ASO"
        "EPI" -> d.tipo == "FICHA_EPI"
        "OS" -> d.tipo == "OS"
        "SEP" -> t.contains("SEP")
        "NR10" -> (t.contains("NR10") || t.contains("NR-10") || t.contains("NR 10")) && !t.contains("SEP")
        else -> {
            val n = doc.key.removePrefix("NR")
            d.tipo == "CERTIFICADO" && (
                t.contains(doc.key) || t.contains("NR-$n") || t.contains("NR $n") || t.contains("NR$n")
                )
        }
    }
}

private fun modeloCertificado(key: String): CertificadoModelo? = when (key) {
    "NR06" -> CertificadoModelo.NR06
    "NR10" -> CertificadoModelo.NR10_BASICO
    "SEP" -> CertificadoModelo.NR10_SEP
    "NR18" -> CertificadoModelo.NR18
    "NR33" -> CertificadoModelo.NR33
    "NR35" -> CertificadoModelo.NR35
    else -> null
}

@Composable
private fun SecaoFicha(titulo: String, content: @Composable () -> Unit) {
    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(titulo, color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
        content()
    }
}

@Composable
private fun Dado(rotulo: String, valor: String) {
    Column {
        Text(rotulo, style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaTexto)
        Text(valor.ifBlank { "—" }, color = PortalCores.Texto)
    }
}

// ---------------------------------------------------------------- Formulário

@Composable
private fun FormColab(
    inicial: Colaborador,
    funcoes: List<String>,
    centros: List<CentroColab>,
    onCancelar: () -> Unit,
    salvar: suspend (Colaborador) -> String?
) {
    val scope = rememberCoroutineScope()
    var c by remember { mutableStateOf(inicial) }
    val opcoesCc = listOf("" to "Não informado") + centros
        .filter { it.ativo || it.id == c.ccId }
        .sortedBy { it.rotulo }
        .map { it.id to it.rotulo }
    val catalogo = docsTela()
    var datas by remember(inicial.id) {
        mutableStateOf(catalogo.filter { !it.marcacao }.associate { it.key to DatasColab.isoParaBr(inicial.docs[it.key].orEmpty()) })
    }
    var outros by remember { mutableStateOf(inicial.outros) }
    var realizadoOutro by remember {
        mutableStateOf(inicial.outros.associate { it.id to DatasColab.isoParaBr(it.realizado) })
    }
    var validadeOutro by remember {
        mutableStateOf(inicial.outros.associate { it.id to DatasColab.isoParaBr(it.validade) })
    }
    var validadeCnh by remember { mutableStateOf(DatasColab.isoParaBr(inicial.cnh.validade)) }
    var erro by remember { mutableStateOf<String?>(null) }
    var salvando by remember { mutableStateOf(false) }
    val situacoes = (SITUACOES + c.situacao).filter { it.isNotBlank() }.distinct()

    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Text(
                if (inicial.id.isBlank()) "Novo colaborador" else "Editar ${inicial.nome}",
                color = PortalCores.Navy,
                fontWeight = FontWeight.Bold,
                style = MaterialTheme.typography.headlineSmall
            )
            Par(
                true,
                { m -> Seletor("Vínculo", listOf("CLT" to "CLT", "PJ" to "PJ"), c.vinculo, { c = c.copy(vinculo = it) }, m) },
                { m -> Seletor("Situação", listOf("" to "Não informada") + situacoes.map { it to it }, c.situacao, { c = c.copy(situacao = it) }, m) }
            )
            Campo("Nome do colaborador", c.nome) { c = c.copy(nome = it.uppercase()) }
            Seletor(
                "Centro de custo/Obra",
                opcoesCc,
                c.ccId,
                { c = c.copy(ccId = it) },
                Modifier.fillMaxWidth(),
                embutido = true
            )
            Par(
                true,
                { m -> Campo("Matrícula (MTR)", c.matricula, modifier = m) { c = c.copy(matricula = it) } },
                { m -> Campo("Função (cargo)", c.funcao, modifier = m) { c = c.copy(funcao = it.uppercase()) } }
            )
            val sugestoes = funcoes.filter { c.funcao.length >= 2 && norm(it).contains(norm(c.funcao)) && it != c.funcao }.take(6)
            if (sugestoes.isNotEmpty()) {
                Row(horizontalArrangement = Arrangement.spacedBy(6.dp), modifier = Modifier.horizontalScroll(rememberScrollState())) {
                    sugestoes.forEach { s ->
                        Text(
                            s,
                            color = PortalCores.Navy,
                            style = MaterialTheme.typography.bodySmall,
                            modifier = Modifier.border(1.dp, PortalCores.Borda, RoundedCornerShape(8.dp)).clickable { c = c.copy(funcao = s) }
                                .padding(horizontal = 8.dp, vertical = 4.dp)
                        )
                    }
                }
            }
            Par(
                true,
                { m -> AppDateTextField(value = c.admissao, onValueChange = { c = c.copy(admissao = it) }, label = "Admissão", modifier = m) },
                { m -> AppDateTextField(value = c.nascimento, onValueChange = { c = c.copy(nascimento = it) }, label = "Data de nascimento", modifier = m) }
            )
            Par(
                true,
                { m -> Campo("RG", c.rg, modifier = m) { c = c.copy(rg = it) } },
                { m -> Campo("CPF", Cpf.formatar(c.cpf), numero = true, modifier = m) { c = c.copy(cpf = Cpf.digitos(it)) } }
            )
            Par(
                true,
                { m -> Campo("CNPJ (PJ)", c.cnpj, modifier = m) { c = c.copy(cnpj = it) } },
                { m -> Campo("CTPS", c.ctps, modifier = m) { c = c.copy(ctps = it) } }
            )
            Par(
                true,
                { m -> Campo("Dir. Def.", c.dirdef, modifier = m) { c = c.copy(dirdef = it) } },
                { m -> Campo("Capacitação", c.capacitacao, modifier = m) { c = c.copy(capacitacao = it) } }
            )

            Text("Documentos", color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
            Text("Informe a data de REALIZAÇÃO; o vencimento é calculado pelas regras.", style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto)
            catalogo.forEach { doc ->
                val valor = c.docs[doc.key].orEmpty()
                val na = valor == "N/A"
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    Column(Modifier.width(150.dp)) {
                        Text(doc.rotulo, fontWeight = FontWeight.SemiBold, color = PortalCores.Texto)
                        Text(doc.descricao, style = MaterialTheme.typography.bodySmall, color = PortalCores.CinzaTexto, maxLines = 2)
                    }
                    Box(Modifier.weight(1f)) {
                        if (doc.marcacao) {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Checkbox(
                                    checked = valor == "OK",
                                    enabled = !na,
                                    onCheckedChange = { ok -> c = c.copy(docs = if (ok) c.docs + (doc.key to "OK") else c.docs - doc.key) }
                                )
                                Text("Entregue (OK)")
                            }
                        } else if (!na) {
                            AppDateTextField(
                                value = datas[doc.key].orEmpty(),
                                onValueChange = { datas = datas + (doc.key to it) },
                                label = "Realizado em"
                            )
                        } else {
                            Text("Não se aplica", color = PortalCores.CinzaTexto)
                        }
                    }
                    TextButton(
                        enabled = c.id.isNotBlank(),
                        onClick = {
                            scope.launch {
                                val arq = PlatformServices.pickDocument() ?: return@launch
                                val tipo = when (doc.key) {
                                    "ASO" -> "ASO"
                                    "EPI" -> "FICHA_EPI"
                                    "OS" -> "OS"
                                    else -> "CERTIFICADO"
                                }
                                FuncionariosApi.enviarDocumento(c.id, arq.bytes, tipo, doc.rotulo, arq.name, false)
                            }
                        }
                    ) { Text(if (c.id.isBlank()) "Salve p/ anexar" else "Anexar") }
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Checkbox(checked = na, onCheckedChange = { marcado ->
                            c = c.copy(docs = if (marcado) c.docs + (doc.key to "N/A") else c.docs - doc.key)
                        })
                        Text("N/A")
                    }
                }
            }
            Text("Outros", color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
            Text(
                "Documento com nome livre. A validade informada entra nos vencimentos.",
                style = MaterialTheme.typography.bodySmall,
                color = PortalCores.CinzaTexto
            )
            outros.forEach { extra ->
                Column(
                    Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp)).padding(10.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        Campo("Nome do documento", extra.nome, modifier = Modifier.weight(1f)) { nome ->
                            outros = outros.map { if (it.id == extra.id) it.copy(nome = nome) else it }
                        }
                        TextButton(onClick = {
                            outros = outros.filter { it.id != extra.id }
                        }) { Text("Remover") }
                    }
                    if (!extra.na) {
                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            AppDateTextField(
                                value = realizadoOutro[extra.id].orEmpty(),
                                onValueChange = { realizadoOutro = realizadoOutro + (extra.id to it) },
                                label = "Realizado em",
                                modifier = Modifier.weight(1f)
                            )
                            AppDateTextField(
                                value = validadeOutro[extra.id].orEmpty(),
                                onValueChange = { validadeOutro = validadeOutro + (extra.id to it) },
                                label = "Validade",
                                modifier = Modifier.weight(1f)
                            )
                        }
                    } else {
                        Text("Não se aplica", color = PortalCores.CinzaTexto)
                    }
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        TextButton(
                            enabled = c.id.isNotBlank() && extra.nome.isNotBlank(),
                            onClick = {
                                scope.launch {
                                    val arq = PlatformServices.pickDocument() ?: return@launch
                                    FuncionariosApi.enviarDocumento(c.id, arq.bytes, "OUTRO", extra.nome.trim(), arq.name, false)
                                }
                            }
                        ) { Text(if (c.id.isBlank()) "Salve p/ anexar" else "Anexar") }
                        Checkbox(
                            checked = extra.na,
                            onCheckedChange = { marcado ->
                                outros = outros.map { if (it.id == extra.id) it.copy(na = marcado) else it }
                            }
                        )
                        Text("N/A")
                    }
                }
            }
            OutlinedButton(onClick = {
                outros = outros + DocOutro(id = "o${br.com.htms.inspeccaocampo.platform.currentTimeMillis()}")
            }) { Text("Adicionar documento") }

            Text("CNH", color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
            CamposCnh(c.cnh, validadeCnh, onCnh = { c = c.copy(cnh = it) }, onValidade = { validadeCnh = it })
            Campo("Observações", c.obs, linhas = 3) { c = c.copy(obs = it) }

            erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
            Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                Button(enabled = !salvando, onClick = {
                    val problema = validar(c, datas, validadeCnh, outros, realizadoOutro, validadeOutro, catalogo)
                    if (problema != null) {
                        erro = problema
                        return@Button
                    }
                    val docs = c.docs.toMutableMap()
                    catalogo.filter { !it.marcacao }.forEach { doc ->
                        if (docs[doc.key] == "N/A") return@forEach
                        val iso = DatasColab.entradaParaIso(datas[doc.key].orEmpty())
                        if (iso.isBlank()) docs.remove(doc.key) else docs[doc.key] = iso
                    }
                    val outrosFinais = outros.mapNotNull { extra ->
                        val nome = extra.nome.trim()
                        if (nome.isBlank()) return@mapNotNull null
                        extra.copy(
                            nome = nome,
                            realizado = if (extra.na) "" else DatasColab.entradaParaIso(realizadoOutro[extra.id].orEmpty()),
                            validade = if (extra.na) "" else DatasColab.entradaParaIso(validadeOutro[extra.id].orEmpty())
                        )
                    }
                    val final = c.copy(
                        nome = c.nome.trim(),
                        docs = docs,
                        outros = outrosFinais,
                        cnh = c.cnh.copy(validade = DatasColab.entradaParaIso(validadeCnh)),
                        admissao = DatasColab.isoParaBr(DatasColab.entradaParaIso(c.admissao)),
                        nascimento = DatasColab.isoParaBr(DatasColab.entradaParaIso(c.nascimento))
                    )
                    salvando = true
                    scope.launch {
                        erro = salvar(final)
                        salvando = false
                    }
                }) { Text(if (salvando) "Salvando..." else "Salvar") }
                OutlinedButton(onClick = onCancelar, enabled = !salvando) { Text("Cancelar") }
            }
        }
    }
}

private fun validar(
    c: Colaborador,
    datas: Map<String, String>,
    validadeCnh: String,
    outros: List<DocOutro>,
    realizadoOutro: Map<String, String>,
    validadeOutro: Map<String, String>,
    docs: List<DocMatriz> = DocsMatriz.todos
): String? {
    if (c.nome.trim().length < 3) return "Informe o nome do colaborador."
    val cpf = Cpf.digitos(c.cpf)
    if (cpf.isNotEmpty() && cpf.length != 11) return "CPF deve ter 11 dígitos."
    fun invalida(v: String) = v.any { it.isDigit() } && DatasColab.entradaParaIso(v).isBlank()
    if (invalida(c.admissao)) return "Data de admissão inválida."
    if (invalida(c.nascimento)) return "Data de nascimento inválida."
    docs.firstOrNull { !it.marcacao && c.docs[it.key] != "N/A" && invalida(datas[it.key].orEmpty()) }?.let {
        return "Data inválida em ${it.rotulo}."
    }
    if (c.cnh.aplica == "sim" && invalida(validadeCnh)) return "Validade da CNH inválida."
    outros.forEach { extra ->
        val nome = extra.nome.trim()
        val feito = realizadoOutro[extra.id].orEmpty()
        val valido = validadeOutro[extra.id].orEmpty()
        if (nome.isBlank() && (feito.any { it.isDigit() } || valido.any { it.isDigit() })) return "Informe o nome do documento personalizado."
        if (nome.isBlank() || extra.na) return@forEach
        if (invalida(feito)) return "Data de realização inválida em $nome."
        if (valido.isBlank() || invalida(valido)) return "Informe a validade de $nome."
    }
    return null
}